import { Feature, Map, MapBrowserEvent, View } from "ol";
import BaseLayer from 'ol/layer/Base';
import { Tile as TileLayer, Group as GroupLayer, Image as ImageLayer, Vector as VectorLayer, Layer } from 'ol/layer';
import { TileArcGISRest, OSM, ImageWMS, TileWMS, Vector, ImageArcGISRest, XYZ } from 'ol/source';
import { defaults as defaultControls, ScaleLine, Attribution, Control, MousePosition } from 'ol/control';
import { defaults as defaultInteractions, DragZoom, Interaction, Draw, DragBox, DragPan } from 'ol/interaction';
import { DrawEvent } from 'ol/interaction/Draw';
import * as extent from 'ol/extent';
import { createEmpty } from 'ol/extent';
import { extend } from 'ol/extent';
import { SimpleGeometry, LineString, Polygon, Geometry, Point, MultiPoint, GeometryCollection } from 'ol/geom';
import { getArea, getLength } from 'ol/sphere';
import { Style, Circle, Stroke, Fill, Text, Icon } from "ol/style";
import { EventsKey } from "ol/events";
import * as condition from "ol/events/condition";
import MapBrowserEventType from "ol/MapBrowserEventType";
import Overlay from 'ol/Overlay';
import { unByKey } from 'ol/Observable';
import { Coordinate } from 'ol/coordinate';
import proj4 from 'proj4';
import { transform, Projection, METERS_PER_UNIT, transformExtent } from 'ol/proj';
import { register } from 'ol/proj/proj4';
import { ObjectEvent } from "ol/Object";
import * as coordinate from "ol/coordinate";
import { WKT, EsriJSON, WMSCapabilities } from "ol/format";
import { requestOptional, rebindEvent, openKendoWindow, getPathToActionMethod, b64toBlob, openKendoWindowContent, createKendoDialog, requestOptionalAsync, requestOptionalUrlAsync, requestOptionalUrl } from 'scripts/Utilities/core';
import { displayMessage, messageType } from 'scripts/Utilities/notification';
import { getResource } from 'scripts/Utilities/resources';
import Geolocation from 'ol/Geolocation.js';
import VectorSource from 'ol/source/Vector';
import KML from 'ol/format/KML';
import { fromExtent } from "ol/geom/Polygon";
import fileDownload from 'js-file-download';
import * as cart from "scripts/Map/cart";
import KMZ from "./KMZ";
import { handleCustomFileUpload, handleMapExport } from "./index";
import TileGrid from "ol/tilegrid/TileGrid";
import { map } from "jquery";
import GeoJSON from 'ol/format/GeoJSON';

declare let globalVariables: any;

interface SelectModel {
    Format: string,
    SpatialReferenceCode: string,
    Objects: any[],
    Geometries: any[]
}

interface ZoomGeometry {
    Format: string,
    SpatialReferenceCode: string,
    Geometry: any
}

interface LegendItem {
    layerNameOnMap?: string,
    id?: number,
    name?: string,
    title?: string,
    parentLayerId?: number,
    defaultVisibility?: boolean,
    subLayerIds?: number[],
    minScale?: number,
    maxScale?: number,
    type?: string,
    supportsDynamicLegends?: boolean,
    geometryType?: string,
    checked?: boolean,
    legend?: string,
    items?: LegendItem[]
}

interface Options {
    mapElement?: string,
    mapMode?: MapModeType
}

interface LayerData {
    name: string,
    objectTypeId?: number,
    layerId: number
}

interface OperationalLayer {
    id: string,
    title: string,
    opacity: number,
    minScale: number,
    maxScale: number,
    url: string,
    visibleLayers?: number[],
    layers?: any[]
}

interface BaseMapLayer {
    id: string,
    layerType: string,
    opacity: number,
    showLegend: boolean,
    title: string,
    visibility: boolean,
    minScale?: number,
    maxScale?: number
}

interface TobelSearchResults {
    success: boolean;
    message?: string;
    featureCount: number;
    extent?: [number, number, number, number];
    featureCollections: SearchFeatureCollection[];
}

interface SearchFeatureCollection {
    title: string;
    layerId: string;
    features: { type: string; geometry: any; properties?: any }[];
    extent: [number, number, number, number];
    epsg: string;
}

export enum MapModeType {
    Cadastre,
    UnapprovedCadastre,
    GeoKartFond,
    BlackSeaCoast,
    Inspire,
    GeoNames
}

enum ArcGisGroupLayers {
    GKF = "GKF",
    COAST_CAD = "CoastCad"
}

interface UploadFileLegendItem {
    text?: string,
    mapName?: string,
    objDescName?: string,
    checked?: boolean,
    children?: UploadFileLegendItem[],
}

export default class MapClass {
    private readonly map: Map;
    private readonly cadHistoryMinDate = new Date(1999, 0, 1, 0, 0, 0);
    private readonly selctionLayerName: string = "selection";
    private readonly drawingLayerName: string = "drawing";
    private readonly selectionLayer: VectorLayer<Vector>;
    private readonly drawingLayer: VectorLayer<Vector>;
    private readonly dpi = 25.4 / 0.28;
    private readonly propertyKeyName: string = "name";
    private readonly propertyKeyActivateChange: string = "activate:change";
    private readonly drawingStyle: Style = new Style({
        image: new Circle({
            radius: 20,
            fill: new Fill({
                color: 'rgba(66,135,245,0.5)'
            })
        }),
        stroke: new Stroke({
            color: "#00BFFF",
            lineCap: "butt",
            lineJoin: "bevel",
            width: 2
        }),
        fill: new Fill({
            color: 'rgba(66,135,245,0.25)'
        })
    });
    private readonly hitToleranceInPixel = 5;
    private readonly options: Options;
    private readonly layerModes: any = {};
    private readonly appartmentLayerData: LayerData[] = [
        {
            name: "cadastre",
            objectTypeId: 3,
            layerId: 3
        },
        {
            name: "unapprovedCadastre",
            objectTypeId: 100003,
            layerId: 100003
        }];

    private readonly restrictionLayerData: LayerData[] = [
        {
            name: "cadastre",
            layerId: 99
        },
        {
            name: "unapprovedCadastre",
            layerId: 100099
        }];

    private readonly restrictionDefaultFilter = "floornumber is null and cadapp is null";

    private readonly restrictionFilters = [];

    private readonly projectLayersData: LayerData[] = [
        {
            name: "cadProjects",
            layerId: 1001
        },
        {
            name: "cadProjects",
            layerId: 1002
        },
        {
            name: "cadProjects",
            layerId: 1003
        },
        {
            name: "cadProjects",
            layerId: 1015
        },
        {
            name: "cadProjects",
            layerId: 1017
        }];

    private readonly cadastreHistoryLayersData: LayerData[] = [
        {
            name: "cadastreHistory",
            layerId: 117
        },
        {
            name: "cadastreHistory",
            layerId: 115
        },
        {
            name: "cadastreHistory",
            layerId: 131
        },
        {
            name: "cadastreHistory",
            layerId: 103
        },
        {
            name: "cadastreHistory",
            layerId: 102
        },
        {
            name: "cadastreHistory",
            layerId: 101
        }];

    private readonly coordinateDecimals = 0;

    private clientProjection: string;
    private clientProjectionName: string;
    private legend: kendo.ui.TreeView;
    private legendMenu: kendo.ui.ContextMenu;

    private measureFeature: Feature;
    private measureGeometryChangeListener: EventsKey;
    private measureTooltip: Overlay;
    private measureHelpTooltip: Overlay;
    private kmlLayer: VectorLayer<VectorSource>;
    private dwgLayers: GroupLayer[] = [];
    private shpLayer: VectorLayer<VectorSource>;
    private mapWindowClass = "map-window-js";
    private gkfPreviewWindowClass = "gkf-preview-window-js";
    private defaultTool = "infoTool";
    private sampleEtkProjection = "EPSG:9391";

    constructor(options?: Options) {
        this.options = options ? options : {};
        this.options.mapElement = this.options.mapElement ? this.options.mapElement : "map";
        this.options.mapMode = this.options.mapMode ? this.options.mapMode : MapModeType.Cadastre;

        proj4.defs("EPSG:7801", "PROJCS[\"BGS2005\", GEOGCS[\"GCS_WGS_1984\", DATUM[\"D_WGS_1984\", SPHEROID[\"WGS_1984\", 6378137.0, 298.257223563]], PRIMEM[\"Greenwich\", 0.0], UNIT[\"degree\", 0.017453292519943295], AXIS[\"Longitude\", EAST], AXIS[\"Latitude\", NORTH]],  PROJECTION[\"Lambert_Conformal_Conic_2SP\"],  PARAMETER[\"central_meridian\", 25.5],   PARAMETER[\"latitude_of_origin\", 42.66787568333],  PARAMETER[\"standard_parallel_1\", 43.33333333333],  PARAMETER[\"false_easting\", 500000.0],  PARAMETER[\"false_northing\", 4725824.3591],  PARAMETER[\"scale_factor\", 1.0],  PARAMETER[\"standard_parallel_2\", 42.0],  UNIT[\"m\", 1.0],  AXIS[\"x\", EAST],  AXIS[\"y\", NORTH],  AUTHORITY[\"EPSG\",\"7801\"]]");
        proj4.defs("EPSG:9391", "+proj=utm +zone=35 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs");
        proj4.defs("EPSG:25835", "+proj=utm +zone=35 +ellps=GRS80 +units=m +no_defs");
        proj4.defs("EPSG:32634", "+proj=utm +zone=34 +datum=WGS84 +units=m +no_defs +type=crs");
        proj4.defs("EPSG:32635", "+proj=utm +zone=35 +datum=WGS84 +units=m +no_defs +type=crs");

        register(proj4);

        for (var i = 0; i < this.restrictionLayerData.length; i++) {
            let t = {};
            t[this.restrictionLayerData[i].layerId] = this.restrictionDefaultFilter;
            this.restrictionFilters.push(t);
        }

        this.map = new Map({
            target: this.options.mapElement,
            view: new View({
                maxZoom: 21,
                minZoom: 8,
                zoom: 8,
                projection: new Projection({
                    code: 'EPSG:7801',
                    units: 'm',
                    axisOrientation: 'neu'
                }),
                center: [530785, 4727071]
            }),
            layers: this.getDefaulLayers(),
            controls: defaultControls({ attribution: false, zoom: false })
                .extend(this.getControls()),
            interactions: defaultInteractions()
        });

        let layerCollection = this.map.getLayers();
        layerCollection.on("add", async (e: any) => {
            let self = this;
            let layer = e.element as BaseLayer;
            if (layer && layer.getProperties()['skipFromLegend'] !== true) {
                let items = await self.getLayersDataSourceAsync([layer]);
                if (items && items.length == 1) {
                    self.legend.dataSource.insert(0, items[0]);
                }
            }
        });
        layerCollection.on("remove", (e: any) => {
            let self = this;
            let layer = e.element as BaseLayer;
            if (layer) {
                let name = layer.getProperties()["name"];
                let legendItem = self.legendSearch(item => item.name == name);
                if (legendItem) {
                    self.legend.dataSource.remove(legendItem);
                }
            }
        });

        this.selectionLayer = this.getLayerByName(this.selctionLayerName) as VectorLayer<Vector>;
        this.drawingLayer = this.getLayerByName(this.drawingLayerName) as VectorLayer<Vector>;

        let interactions = this.getInteractions();
        for (let i = 0; i < interactions.length; i++) {
            interactions[i].setActive(false);
            this.map.addInteraction(interactions[i]);
            interactions[i].on("change:active", this.onInteractionActiveChange);
        }

        this.init();
    }

    public getExtent = () => {
        let self = this;
        let view = self.map.getView();
        return {
            Extent: view.calculateExtent(self.map.getSize()),
            Projection: view.getProjection().getCode()
        };
    };

    private init = async () => {
        let self = this;
        self.bindEvents();
        self.initLayerModes();

        $(async () => {
            self.initLegend();
            $(".baseMap-js:first").trigger("click");
            self.activateDefaultTool();
            await self.setMapModeAsync(self.options.mapMode);
            self.initProjection();
            self.initScale();
        })
    };

    private activateDefaultTool = () => {
        let self = this;
        if (self.defaultTool) {
            $(`.tool-js#${self.defaultTool}`).trigger("click");
        }
    }

    private initLayerModes = () => {
        let self = this;
        self.layerModes[MapModeType.Cadastre] = ["administrative", "cadastre"];
        self.layerModes[MapModeType.UnapprovedCadastre] = ["administrative", "unapprovedCadastre"];
        self.layerModes[MapModeType.GeoKartFond] = ["geoKartFond"];
        self.layerModes[MapModeType.BlackSeaCoast] = ["blackSeaCoast"];
        self.layerModes[MapModeType.Inspire] = [];
        self.layerModes[MapModeType.GeoNames] = ["geoNames"];
    };

    private bindEvents = () => {
        let self = this;

        $(document).on("keydown", null, (e: JQuery.KeyboardEventBase) => {
            if (e.originalEvent.key != "Escape") {
                return;
            }

            e.preventDefault();
            self.activateDefaultTool();
        });

        self.map.on('loadstart', function () {
            self.map.getTargetElement().classList.add('spinner');
        });
        self.map.on('loadend', function () {
            self.map.getTargetElement().classList.remove('spinner');
        });

        let view = self.map.getView();
        view.on("change:resolution", (e: ObjectEvent) => {
            self.initScale();
            // TODO - init MapServerLegend -
        });
        view.on("change:center", (e: ObjectEvent) => {
            self.initCoordinates();
        });
        $(function () {
            if (window.innerWidth <= 980) {
                $('.map-control .triggers .pane.bottom').addClass('hidden');
            }
        });

        $(window).on("resize", () => {
            let self = this;
            self.checkMapHeight();
            if (window.innerWidth <= 980) {
                $('.map-control .triggers .pane.bottom').addClass('hidden');
            } else {
                $('.map-control .triggers .pane.bottom').removeClass('hidden');
            }
        });
        rebindEvent("keypress", "#scale, #xCoordinate, #yCoordinate", (e: JQuery.TriggeredEvent) => {
            let self = this;
            if (e.key != "Enter") {
                return;
            }

            e.preventDefault();
            self.changeScaleAndPanToCoordinates();
        });
        rebindEvent("click", ".js-search-cordinates", (e: JQuery.TriggeredEvent) => {
            let self = this;
            e.preventDefault();
            self.changeScaleAndPanToCoordinates();
        });
        rebindEvent("click", "#legendMenu .zoom-js", (e: JQuery.TriggeredEvent) => {
            let self = this;
            let legendItem = self.getActiveLegendItem();
            if (!legendItem) {
                return;
            }

            self.zoomToLayer(legendItem.name);
        });
        rebindEvent("click", "#legendMenu .historicmoment-js", (e: JQuery.TriggeredEvent) => {
            let self = this;
            let legendItem = self.getActiveLegendItem();
            let layer = legendItem && legendItem.name ? self.getLayerByName(legendItem.name) as Layer : null;
            if (!layer) {
                return;
            }

            let minDate = layer.getProperties()["minDate"] as Date;
            let source = self.getArcGisLayerSource(layer);
            let historicMoment = source.getParams()["historicMoment"] as number;
            let historyDate = self.getHistoryDate(historicMoment);

            let historicMomentPicker: kendo.ui.DateTimePicker;
            let actions = [
                {
                    text: getResource("Change"),
                    action: () => {
                        let date = historicMomentPicker.value();
                        if (!date) {
                            displayMessage(getResource("InvalidDate"), messageType.warning);
                            return false;
                        }

                        self.updateHistoryMoment(date.valueOf());
                        return true;
                    }
                },
                {
                    text: getResource("Cancel")
                }
            ];

            let dateTimePickerId = kendo.guid();
            createKendoDialog({
                title: getResource("Change"),
                content: `<input id=\"${dateTimePickerId}\" required/>`,
                visible: true,
                actions: actions
            });
            historicMomentPicker = $(`#${dateTimePickerId}`).kendoDateTimePicker({ value: historyDate, min: minDate }).data("kendoDateTimePicker") as kendo.ui.DateTimePicker;
        });
        rebindEvent("click", "#legendMenu .remove-js", (e: JQuery.TriggeredEvent) => {
            let self = this;
            let legendItem = self.getActiveLegendItem();
            if (!legendItem) {
                return;
            }

            let layer = self.getLayerByName(legendItem.name);
            if (!layer) {
                return;
            }

            self.map.removeLayer(layer);
            displayMessage(getResource("SuccessfullyRemovedLayer"), messageType.success);
        });
        rebindEvent("click", ".tool-js", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let self = this;
            let sender = $(e.currentTarget);
            let toolName = sender.attr("id");
            let tool = self.findInteractionByFilter((interaction) => interaction.get(self.propertyKeyName) === toolName);
            if (tool) {
                if (tool.getActive()) {
                    if (toolName != self.defaultTool) {
                        self.activateDefaultTool();
                    }
                }
                else {
                    tool.setActive(true);
                }
            }
        });
        rebindEvent('click', '.mc-controlbox-inner-new', (e: JQuery.TriggeredEvent) => {
            let sender = $(e.currentTarget);
            if (!sender.hasClass('toggle')) {
                sender.addClass('toggle');
            }
            else if (e.target.tagName !== "INPUT") {
                sender.removeClass('toggle');
            }
        });
        rebindEvent('click', '#moreTools', (e: JQuery.TriggeredEvent) => {
            $('.map-control .triggers .pane.bottom').toggleClass('hidden');
        });
        rebindEvent('click', '.map-control .triggers a:not(.tool-js)', (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let sender = $(e.currentTarget);
            let wrapper = sender.closest(".map-control");
            wrapper.find('.triggers a.active:not(".tool-js")').not(sender).removeClass('active');
            if (sender.hasClass("js-hover-trigger")) {
                $(sender.attr("href")).css({ "left": sender.position().left + "px" }).toggleClass('opened').siblings('.opened').removeClass('opened');
                wrapper.find('.bottom .opened, .top .opened').removeClass('opened');
                sender.toggleClass('opened').siblings('.opened').removeClass('opened');
            }
            else {
                wrapper.find(".opened").removeClass('opened');
            }

            $('#map_wrap').on('click', function onMapDropdownHide(e) {
                var targetElement = e.target as any;
                if (!$('.js-hover-trigger, .map-dropdown').is(targetElement) && !$('.js-hover-trigger, .map-dropdown').has(targetElement).length) {
                    wrapper.find(".opened").removeClass('opened');
                    $('#map_wrap').off('click', onMapDropdownHide)
                }
            })
        });
        rebindEvent('hover', '.map-control .triggers .js-hover-trigger', (e: JQuery.TriggeredEvent) => {
            let self = this;
            let sender = $(e.currentTarget);
            let hoverIn = e.type == "mouseenter";
            if (hoverIn) {
                $(sender.attr("href")).css({ "top": sender.position().top }).addClass('opened');
            }
            else {
                $(sender.attr("href")).removeClass('opened');
            }

            self.checkMapHeight();
        });
        rebindEvent('hover', '.map-dropdown', (e: JQuery.TriggeredEvent) => {
            let sender = $(e.currentTarget);
            let hoverIn = e.type == "mouseenter";
            if (hoverIn) {
                sender.addClass('active');
                $(`.triggers > a[href="${sender.attr("id")}"]`).addClass("active");
            }
            else {
                sender.removeClass('active');
                $(`.triggers > a[href="#${sender.attr("id")}"]`).removeClass("active");
            }
        });
        rebindEvent('click', '.object-option.zoom-js', (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let self = this;
            let sender = $(e.currentTarget);
            let listView = sender.closest(".k-listview").data("kendoListView") as kendo.ui.ListView;
            let object = listView ? listView.dataItem(sender.closest(".k-listview-item") as JQuery) : null;
            if (!object) {
                return;
            }

            let mapObject = object.toJSON();
            let isAppartment = self.appartmentLayerData.find((item) => item.objectTypeId == mapObject["Type"]);
            requestOptional(
                "GetGeometry",
                "Map",
                {
                    type: "POST",
                    data: mapObject,
                    success: (data: ZoomGeometry[]) => {
                        data = data ? data.filter((item) => item.Geometry) : data;
                        let floornumber: any;
                        if (data && data.length > 0 && isAppartment) {
                            if (mapObject["FloorNumber"]) {
                                floornumber = mapObject["FloorNumber"];
                            }

                            if (!floornumber) {
                                floornumber = listView.element.data("floornumber");
                            }

                            if (!floornumber) {
                                let first = data[0];
                                floornumber = first["Attributes"] && first["Attributes"]["floornumber"]
                                    ? first["Attributes"]["floornumber"]
                                    : null;
                            }

                            if (floornumber) {
                                data = data.filter((item) => item["Attributes"] && item["Attributes"]["floornumber"] == floornumber);
                            }
                        }

                        if (!data || data.length < 1) {
                            return;
                        }

                        let features = [];
                        for (var i = 0; i < data.length; i++) {
                            let feature = self.createFeatureFromZoomGeometry(data[i]);
                            if (!feature) {
                                return;
                            }

                            features.push(feature);
                        }

                        if (!features) {
                            return;
                        }

                        let selectionSource = self.selectionLayer.getSource();
                        selectionSource.clear(true);
                        selectionSource.addFeatures(features);

                        self.zoomToExtent(selectionSource.getExtent());

                        if (isAppartment) {
                            self.updateApartmentLayerFilterByObject(mapObject["Number"], mapObject["Type"], floornumber);
                            self.updateRestrictionLayerFilterByObject(mapObject["Number"], mapObject["Type"], floornumber);
                        }
                    }
                });
        });
        rebindEvent('click', '.object-option.info-js', (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let self = this;
            let sender = $(e.currentTarget);
            let listView = sender.closest(".k-listview").data("kendoListView") as kendo.ui.ListView;
            let object = listView ? listView.dataItem(sender.closest(".k-listview-item") as JQuery) : null;
            if (!object) {
                return;
            }

            let json = object.toJSON();
            if (json["Type"] == "8888" && typeof json["Description"] === "string") {
                json["Description"] = json["Description"].split("|")[0] || "";
            }

            openKendoWindow(
                "GetObjectInfo",
                "Map",
                {
                    type: "GET",
                    data: json
                },
                {
                    title: `${getResource("Info")}: ${json["Title"]}`,
                    classAttribute: self.mapWindowClass,
                    width: 500,
                    open: (e) => {
                        self.initFloorsDropDown(e.sender.wrapper);
                        e.sender.wrapper.addClass('info-window')
                    }
                }
            );
        });
        rebindEvent('click', '.object-option.lot-info-js', (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let self = this;
            let sender = $(e.currentTarget);
            let listView = sender.closest(".k-listview").data("kendoListView") as kendo.ui.ListView;
            let object = listView ? listView.dataItem(sender.closest(".k-listview-item") as JQuery) : null;
            if (!object) {
                return;
            }

            let json = object.toJSON();
            openKendoWindow(
                "GetObjectLotInfo",
                "Map",
                {
                    type: "GET",
                    data: json
                },
                {
                    title: `${getResource("LotInfo")}: ${json["Title"]}`,
                    classAttribute: self.mapWindowClass,
                    width: "40%",
                    height: "60%",
                    position: {
                        top: 90
                    }
                }
            );
        });
        rebindEvent('click', '#attach-preview', (e: JQuery.TriggeredEvent) => {
            let self = this;
            e.preventDefault();
            let sender = $(e.currentTarget);
            let objectId = sender.attr("data-target");
            if (!objectId) {
                return;
            }

            openKendoWindow(
                "GetObjectDocPreview",
                "Map",
                {
                    type: "GET",
                    data: { Id: objectId }
                },
                {
                    title: getResource("Preview"),
                    classAttribute: self.gkfPreviewWindowClass,
                    resizable: false,
                    autoFocus: false,
                    open: (e) => {
                        e.sender.wrapper.css({ top: 20, left: 80 });
                    },
                }
            );
        });
        rebindEvent("click", "#download-specMapToDate-shp", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let sender = $(e.currentTarget);
            let objectId = sender.attr("data-target");
            if (!objectId) {
                return;
            }
            $.ajax({
                url: globalVariables.publicSpecializedDocumentsUrl,
                data: JSON.stringify({
                    "id": objectId,
                }),
                contentType: "application/json; charset=utf-8",
                type: "POST",
                success: function (data) {
                    if (data.data) {
                        fileDownload(b64toBlob(data.data), `${objectId}.zip`);
                    }
                    else {
                        displayMessage(getResource("NoDataFound"), messageType.warning);
                    }
                },
                error: function (error) {
                    console.error(error);
                }
            });
        });
        rebindEvent("click", "#description-download", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            const sender = $(e.currentTarget);
            const dataTarget = sender.attr("data-target");
            const splittedDataTarget = dataTarget.split("|");
            const id = splittedDataTarget[0];
            const layerId = splittedDataTarget[1];

            $.ajax({
                url: globalVariables.gkfDescDownloadUrl,
                data: JSON.stringify({
                    "id": id,
                    "layerId": parseInt(layerId)
                }),
                contentType: "application/json; charset=utf-8",
                type: "POST",
                success: function (data: { data: string, message?: string }) {
                    if (data.data) {
                        const fileName = `${new Date().getTime()}`.substring(8);
                        fileDownload(b64toBlob(data.data), `${fileName}.zip`);
                    } else {
                        displayMessage(getResource("NoDataFound"), messageType.warning);
                    }
                },
                error: function (error) {
                    console.error(error);
                }
            })
        });
        rebindEvent('change', '.object-control input[type=checkbox]', (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let sender = $(e.currentTarget);
            let type = sender.data("type");
            requestOptional(
                "ChangeCartObjectsByType",
                "Map",
                {
                    type: "POST",
                    data: {
                        type: type,
                        addToCart: sender.is(':checked')
                    },
                    success: (cartItems: number) => {
                        if (!cartItems && cartItems != 0) {
                            return;
                        }

                        self.refreshResult();
                        cart.refresh();
                    }
                });
        });
        rebindEvent("click", ".mapMode-js", async (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let self = this;
            let sender = $(e.currentTarget);
            await self.setMapModeAsync(MapModeType[sender.data("mode") as string]);
        });
        rebindEvent("click", ".baseMap-js", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let self = this;
            let sender = $(e.currentTarget);
            let layerName = sender.data("layer") as string;
            self.setBaseMap(layerName ? layerName : '');
        });
        rebindEvent("click", "#pinCommand", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let self = this;
            const geolocation = new Geolocation({
                projection: view.getProjection(),
            });
            geolocation.once("change", (evt) => {
                geolocation.setTracking(false);
                let position = geolocation.getPosition();
                if (position) {
                    const positionFeature = new Feature({
                        geometry: new Point(position),
                    });
                    positionFeature.setStyle(new Style({
                        image: new Icon({
                            anchor: [0.5, 1],
                            scale: 0.08,
                            src: '/images/location.png',
                        })
                    }));

                    let vectorLayer = self.getLayerByName("geolocation") as VectorLayer<Vector>;
                    if (!vectorLayer) {
                        const vectorSource = new VectorSource({
                            features: [positionFeature]
                        });
                        const vectorLayer = new VectorLayer({
                            source: vectorSource,
                            properties: {
                                name: "geolocation"
                            }
                        });
                        self.map.addLayer(vectorLayer);
                    }
                    else {
                        let vectorSource = vectorLayer.getSource();
                        vectorSource.clear(true);
                        vectorSource.addFeature(positionFeature);
                    }

                    self.zoomToExtent(new Point(position));
                    self.openNewMapWindow(
                        coordinate.format(position, `${self.clientProjectionName} {y}, {x}`, self.coordinateDecimals),
                        {
                            title: getResource("Coordinates"),
                            width: 260,
                            open: (e) => {
                                e.sender.wrapper.css({
                                    top: window.innerHeight / 2 + 20,
                                });
                            }
                        },
                        true);
                }
            });
            geolocation.once("error", (evt) => {
                geolocation.setTracking(false);
            })
            geolocation.setTracking(true);
        });
        rebindEvent("click", "#deselectCommand", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let self = this;
            requestOptional(
                "ClearSelection",
                "Map",
                {
                    type: 'POST',
                    success: function () {
                        self.selectionLayer.getSource().clear(true);
                        self.refreshResult((listView) => listView.dataSource.total() > 0);
                    },
                });
        });
        rebindEvent("click", "#etk-mark", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let self = this;
            const { inputTop, inputLeft, inputRight, inputBottom } = self.getSampleEtkExpentInput();
            self.sampleEtkValidationMsg(inputTop, inputLeft, inputRight, inputBottom);
            if (!self.isValidSampleEtkExtent(inputTop, inputBottom, inputLeft, inputRight)) {
                return;
            }

            if ((inputTop + inputLeft + inputRight + inputBottom) > 0) {
                const mapProjection = self.map.getView().getProjection();
                const feature = new Feature({
                    geometry: fromExtent([inputRight, inputBottom, inputLeft, inputTop]).transform(self.sampleEtkProjection, mapProjection),
                });
                const selectionSource = self.selectionLayer.getSource();
                selectionSource.clear(true);
                feature.setId("etkMarkFeature");
                selectionSource.addFeature(feature);
            }
        });
        rebindEvent("click", "#etk-zoom-in", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let self = this;
            const { inputTop, inputLeft, inputRight, inputBottom } = self.getSampleEtkExpentInput();
            self.sampleEtkValidationMsg(inputTop, inputLeft, inputRight, inputBottom);
            if (!self.isValidSampleEtkExtent(inputTop, inputBottom, inputLeft, inputRight)) {
                return;
            }

            if ((inputTop + inputLeft + inputRight + inputBottom) > 0) {
                const targetExtent = [inputRight - 250, inputBottom - 250, inputLeft + 250, inputTop + 250];
                self.zoomToExtent(targetExtent, self.sampleEtkProjection);
            }
        });
        rebindEvent("click", "#download-specialized-map", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            window.location.href = globalVariables.downloadAllSpecializedMaps;
        });
        rebindEvent("click", "#catalog-link", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            window.open(globalVariables.downloadCatalog, "_blank");
        });
        rebindEvent("click", "#createCoordinatesRow", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();

            const coordinateSystemList = $("#CoordinateSystemsPicker").data("kendoDropDownList") as kendo.ui.DropDownList;
            const selectedCSValue = coordinateSystemList.value();

            let xLabel = 'X (m)';
            let yLabel = 'Y (m)';

            if (selectedCSValue === '2') {
                xLabel = 'φ';
                yLabel = 'λ';
            }

            let targetGrid = $("#PointCoordinates").data("kendoGrid") as kendo.ui.Grid;
            if (targetGrid) {
                let data = targetGrid.dataSource.data();
                let dataAsArr = data.toJSON();
                let lastId = 0;
                if (dataAsArr.length) {
                    const lastRecord = dataAsArr.sort((a, b) => b.Number - a.Number)[0];
                    lastId = lastRecord.Number;
                }
                targetGrid.dataSource.add({ XLabel: xLabel, YLabel: yLabel, Number: lastId + 1, NumberLabel: `№ ${lastId + 1}` });

                targetGrid.refresh();
                targetGrid.editRow(targetGrid.tbody.children().last());
            }
        });
        rebindEvent("click", "#goToCoordinates", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();

            let targetGrid = $("#PointCoordinates").data("kendoGrid") as kendo.ui.Grid;
            if (targetGrid) {
                let selectedRows = (targetGrid as any).getSelectedData();
                const coordinateSystemList = $("#CoordinateSystemsPicker").data("kendoDropDownList") as kendo.ui.DropDownList;
                const selectedCSValue = coordinateSystemList.value();

                let features: Feature[];
                if (selectedRows && selectedRows.length) {
                    features = self.getFeaturesFromDataSource(selectedRows, selectedCSValue);
                } else {
                    let data = targetGrid.dataSource.data();
                    features = self.getFeaturesFromDataSource(data, selectedCSValue);
                }

                const selectionSource = this.selectionLayer.getSource();
                selectionSource.clear(true);
                selectionSource.addFeatures(features);
                selectionSource.getExtent();

                self.zoomToExtent(selectionSource.getExtent());
            }
        });
        rebindEvent("click", "#removeRow", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();

            let targetGrid = $("#PointCoordinates").data("kendoGrid") as kendo.ui.Grid;
            if (targetGrid) {
                let selectedRows = (targetGrid as any).getSelectedData();
                if (selectedRows.length) {
                    targetGrid.dataSource.remove(selectedRows[0])
                } else {
                    let data = targetGrid.dataSource.data();
                    if (data.length > 0) {
                        targetGrid.dataSource.remove(data[data.length - 1]);
                    }
                }
            }
        });
        rebindEvent("click", "#extentFileUpload", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            $('#extentFileUploadInput').trigger("click");
        });
        rebindEvent("click", "#fileImageContainer", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let targetGrid = $("#UploadedFile").data("kendoGrid") as kendo.ui.Grid;
            //let data = null
            if (targetGrid) {
                //data = { ...targetGrid.dataSource.data() };
                targetGrid.dataSource.data().empty();
            }
            //let fileName = '';
            //if (data.length) {
            //    fileName = data[0]['FileName']
            //}
            $('#extentFileUploadInput').val('');
            $(".epsg-select")?.hide();

            // TO DO remove by layer name
            if (this.kmlLayer) {
                this.map.removeLayer(this.kmlLayer);
                this.kmlLayer = null;
            }
            else if (this.dwgLayers.length) {
                this.dwgLayers.forEach(dwgLayer => this.map.removeLayer(dwgLayer));
                this.dwgLayers.length = 0;
            }
            else if (this.shpLayer) {
                this.map.removeLayer(this.shpLayer);
                this.shpLayer = null;
            }

        });
        rebindEvent("change", "#extentFileUploadInput", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let files = (e.target as any).files;
            let targetGrid = $("#UploadedFile").data("kendoGrid") as kendo.ui.Grid;
            let epsgWrapper = $(".epsg-select");
            if (targetGrid) {
                const targetFile = files[0];
                const fileName = targetFile?.name;
                const fileSize = targetFile?.size && !isNaN(targetFile.size) ? Math.ceil(targetFile.size / 1024) : 0;
                let fileType = '';
                if (fileName && fileName.match(/.dwg$/)) {
                    fileType = 'dwg';
                    epsgWrapper?.show();
                    $("#epsgPicker").data("kendoDropDownList")?.select(0);
                } else if (fileName && fileName.match(/.kmz$/)) {
                    fileType = 'kmz';
                    epsgWrapper?.hide();
                } else if (fileName && fileName.match(/.kml$/)) {
                    fileType = 'kml';
                    epsgWrapper?.hide();
                } else {
                    epsgWrapper?.hide();
                    targetGrid.dataSource.data().empty();
                    targetGrid.refresh();
                    return;
                }
                //if (fileName.match(/.dwg$/)) {
                //    fileType = 'dwg';
                //    epsgWrapper?.show();
                //    $("#epsgPicker").data("kendoDropDownList")?.select(0);
                //} else if (fileName.match(/.kml$/)) {
                //    fileType = 'kml';
                //    epsgWrapper?.hide();
                //} else if (fileName.match(/.kmz$/)) {
                //    fileType = 'kmz';
                //    epsgWrapper?.hide();
                //} else {
                //    fileType = 'zip';
                //    epsgWrapper?.hide();
                //}
                targetGrid.dataSource.data().empty();
                targetGrid.dataSource.add({ FileName: fileName, FileSize: fileSize, FileType: fileType });
                targetGrid.refresh();
            }
        });
        rebindEvent("change", "#CoordinateSystemsPicker", (e: JQuery.TriggeredEvent) => {
            let targetGrid = $("#PointCoordinates").data("kendoGrid") as kendo.ui.Grid;
            if (targetGrid) {
                let data = targetGrid.dataSource.data();
                let dataAsArr = JSON.parse(JSON.stringify(data.toJSON()));
                let xLabel = 'X (m)';
                let yLabel = 'Y (m)';

                if (e.target.value === '2') {
                    xLabel = 'φ';
                    yLabel = 'λ';
                }

                targetGrid.dataSource.data().empty();

                dataAsArr.forEach(d => {
                    if (isNaN(Number(d.XLabel))) {
                        d.XLabel = xLabel;
                    }
                    if (isNaN(Number(d.YLabel))) {
                        d.YLabel = yLabel;
                    }
                    targetGrid.dataSource.add(d);
                });
            }
        });
        rebindEvent("click", "#load-file-button", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let self = this;
            let targetInput = $("#extentFileUploadInput") as any;
            if (targetInput) {
                const targetFile = targetInput[0].files[0];
                if (targetFile.size > 1024 * 1024 * 10) {
                    return;
                }
                if (targetFile && self.checkFileTypeFromName(targetFile.name, '.dwg')) {
                    let wkidVal = $("#epsgPicker").data("kendoDropDownList")!.value();
                    handleCustomFileUpload(targetFile, 'dwg', wkidVal);
                    return;
                }
                //if (targetFile && self.checkFileTypeFromName(targetFile.name, '.zip')) {
                //    handleCustomFileUpload(targetFile, 'shp');
                //    return;
                //}
                if (targetFile) {
                    const fr = new FileReader();
                    let format = new KML();
                    fr.onload = () => {
                        const kmlOptions = {
                            featureProjection: self.map.getView().getProjection()
                        }
                        const features = format.readFeatures(fr.result, kmlOptions);
                        const flattenedFeatures = new Array<Feature>();
                        for (var i = 0; i < features.length; i++) {
                            const f = features[i];
                            const geom = f.getGeometry();
                            const type = geom.getType();
                            const props = f.getProperties();
                            const name = props && props.name ? props.name : "";
                            if (type === 'Point' || type === 'MultiPoint') {
                                f.setStyle(self.customStyleToKmlPointFeature(name));
                            }
                            if (type === "GeometryCollection") {
                                const _geometries = (geom as GeometryCollection).getGeometriesArrayRecursive();
                                for (var y = 0; y < _geometries.length; y++) {
                                    let _feat = new Feature(props);
                                    if (_feat) {
                                        const _geom = _geometries[y];
                                        const _type = _geom.getType();
                                        const _name = name ? `${name}(${y + 1})` : "";
                                        _feat.set("name", _name);
                                        _feat.setGeometry(_geom);
                                        if (_type === 'Point' || _type === 'MultiPoint') {
                                            _feat.setStyle(self.customStyleToKmlPointFeature(_name));
                                        } else {
                                            _feat.setStyle(f.getStyle());
                                        }
                                        flattenedFeatures.push(_feat);
                                    }
                                }
                            } else {
                                flattenedFeatures.push(f);
                            }
                        }

                        if (!self.kmlLayer) {
                            self.addKmlLayer(format, flattenedFeatures, targetFile.name);
                        }
                        else {
                            self.map.removeLayer(self.kmlLayer);
                            self.addKmlLayer(format, flattenedFeatures, targetFile.name);
                        }

                        const geometryFeature = features.find(f => f.getGeometry());
                        if (geometryFeature) {
                            const featureExtent = geometryFeature.getGeometry().getExtent() || [];
                            features.forEach(feature => extent.extend(featureExtent, feature.getGeometry().getExtent()))
                            const polygonFromExtent = fromExtent(featureExtent);
                            polygonFromExtent.scale(1.2);
                            const scaledExtent = polygonFromExtent.getExtent();
                            self.kmlLayer.setExtent(scaledExtent);
                            self.zoomToExtent(scaledExtent);
                        }

                        self.addFeaturesToCart(flattenedFeatures, targetFile.name);
                    }
                    if (self.checkFileTypeFromName(targetFile.name, '.kmz')) {
                        format = new KMZ();
                        fr.readAsArrayBuffer(targetFile);
                    } else {
                        fr.readAsText(targetFile);
                    }
                }
            }
        });
        rebindEvent("click", "#selectByKml", (e: JQuery.TriggeredEvent) => {
            let self = this;
            e.preventDefault();
            let sender = $(e.currentTarget);
            let kmlGeomDesc = sender.attr("data-target");
            if (!kmlGeomDesc) {
                return;
            }
            self.selectObjects(null, true, kmlGeomDesc);
        });
        rebindEvent("click", "#etk-add-to-cart", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let self = this;
            const { inputTop, inputLeft, inputRight, inputBottom } = self.getSampleEtkExpentInput();
            self.sampleEtkValidationMsg(inputTop, inputLeft, inputRight, inputBottom);
            if (!self.isValidSampleEtkExtent(inputTop, inputBottom, inputLeft, inputRight)) {
                return;
            }

            const id = self.getRandomId();
            const sampleEtkDescription = `{ "xmin": ${inputBottom}, "ymin": ${inputRight}, "xmax": ${inputTop}, "ymax": ${inputLeft} }`;
            const object = {
                Id: id,
                Type: 207, // SampleEtk = 207,
                SubType: 'SampleEtk',
                Number: getResource("SampleEtk"),
                Title: `${getResource("TopoMapsSample")} ("xmin": ${inputBottom}, "ymin": ${inputRight}, "xmax": ${inputTop}, "ymax": ${inputLeft})`,
                Description: sampleEtkDescription,
                IsChecked: false
            }

            requestOptional(
                "AddSelectedMap",
                "Map",
                {
                    type: "POST",
                    data: {
                        objects: [object],
                        addToCart: true,
                        intersectKey: "SelectedCartObjectsKey"
                    },
                    success: (cartItems: number) => {
                        if (!cartItems && cartItems != 0) {
                            return;
                        }

                        cart.refresh();
                    }
                });
        });
        rebindEvent("blur", "#ToDate", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            const input = $(e.target)!.val();
            const inputStr = "" + input;
            if (inputStr.indexOf("day") > -1 || inputStr.indexOf("month") > 1 || inputStr.indexOf("year") > -1) {
                const date = new Date();
                date.setDate(date.getDate() - 1);
                const day = "0" + date.getDate();
                const month = "0" + (date.getMonth() + 1);
                const year = date.getFullYear();
                const formatted = "" + day.slice(-2) + "/" + month.slice(-2) + "/" + year;
                $(e.target)!.val(formatted);
            }
        });
        rebindEvent("change", "input.k-input-geolocation", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let sender = $(e.currentTarget);
            let form = sender.closest("form");
            let geolocationInput = sender!.val();
            let extentCheckbox = form.find("[name='LimitSearchExtent']");
            let keywordsInput = form.find("[name='KeyWords']");
            let adminInput = form.find(".k-admin-geolocation")
            if (geolocationInput != "") {
                extentCheckbox!.attr("disabled", "disabled");
                extentCheckbox!.prop('checked', false);
                keywordsInput!.prop("required", false);
                keywordsInput!.removeClass("input-validation-error");
                adminInput!.attr("disabled", "disabled");
            } else {
                extentCheckbox!.removeAttr("disabled");
                keywordsInput!.prop("required", true);
                adminInput!.removeAttr("disabled");
            }
        });
        rebindEvent("change", "input.k-admin-geolocation", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let sender = $(e.currentTarget);
            let form = sender.closest("form");
            let adminInput = sender!.val();
            let extentCheckbox = form.find("[name='LimitSearchExtent']");
            let keywordsInput = form.find("[name='KeyWords']");
            let geolocationInput = form.find(".k-input-geolocation")
            let idInputEl = form.find("input[name='GeoAdminObject']");
            if (adminInput != "") {
                extentCheckbox!.attr("disabled", "disabled");
                extentCheckbox!.prop('checked', false);
                keywordsInput!.prop("required", false);
                keywordsInput!.removeClass("input-validation-error");
                geolocationInput!.attr("disabled", "disabled");
            } else {
                extentCheckbox!.removeAttr("disabled");
                keywordsInput!.prop("required", true);
                geolocationInput!.removeAttr("disabled");
                idInputEl.val("");
            }
        });
        rebindEvent("change", "[name='LimitSearchExtent']", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let sender = $(e.currentTarget);
            let form = sender.closest("form");
            let keywordsInput = form.find(".k-input-keywords");
            let extentCheckbox = $(e.currentTarget).data("kendoCheckBox") as kendo.ui.CheckBox;
            if (extentCheckbox.check()) {
                keywordsInput!.prop("required", false);
                keywordsInput!.removeClass("input-validation-error");
            } else {
                keywordsInput!.prop("required", true);
            }
        });
        rebindEvent("click", "#submit-search", (e: JQuery.TriggeredEvent) => {
            let targetIds = ["IsToBeExportedTriangulation", "IsToBeExportedGnlpGnss", "IsToBeExportedGnlpObjects", "IsToBeExportedPhotogrammetry", "IsToBeExportedLandBalance", "IsToBeExportedOtherTopoMaps", "IsToBeExportedLevelCycleIII", "IsToBeExportedLevelCycleIV", "IsToBeExportedLevelCycleV", "IsToBeExportedLevelBoundary", "IsToBeExportedLevelMareographic", "IsToBeExportedGravimetricPoints", "IsToBeExportedTideStations", "IsToBeExportedLargeScaleTopoMaps70", "IsToBeExportedArchivePlan", "IsToBeExportedLargeScaleTopoMaps50", "IsToBeExportedLargeScaleTopoMaps2005", "IsToBeExportedCoastCadSpecialized", "IsToBeExportedCoastCadSpecializedToDate", "IsToBeExportedCoastCadSpecializedToDate", "IsToBeExportedCoastCadRegister"];
            for (let i = 0; i < targetIds.length; i++) {
                let targetCheckBox = $(`#${targetIds[i]}`).data("kendoCheckBox") as kendo.ui.CheckBox;
                if (targetCheckBox) {
                    targetCheckBox.check(false);
                }
            }
        });
        rebindEvent("click", "#exportButton", (e: JQuery.TriggeredEvent) => {
            let targetIds = ["IsToBeExportedTriangulation", "IsToBeExportedGnlpGnss", "IsToBeExportedGnlpObjects", "IsToBeExportedPhotogrammetry", "IsToBeExportedLandBalance", "IsToBeExportedOtherTopoMaps", "IsToBeExportedLevelCycleIII", "IsToBeExportedLevelCycleIV", "IsToBeExportedLevelCycleV", "IsToBeExportedLevelBoundary", "IsToBeExportedLevelMareographic", "IsToBeExportedGravimetricPoints", "IsToBeExportedTideStations", "IsToBeExportedLargeScaleTopoMaps70", "IsToBeExportedArchivePlan", "IsToBeExportedLargeScaleTopoMaps50", "IsToBeExportedLargeScaleTopoMaps2005", "IsToBeExportedCoastCadSpecialized", "IsToBeExportedCoastCadSpecializedToDate", "IsToBeExportedCoastCadSpecializedToDate", "IsToBeExportedCoastCadRegister"];
            for (let i = 0; i < targetIds.length; i++) {
                let targetCheckBox = $(`#${targetIds[i]}`).data("kendoCheckBox") as kendo.ui.CheckBox;
                if (targetCheckBox) {
                    targetCheckBox.check(true);
                }
            }
        });
        rebindEvent("click", "#uploadFileToMap", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let self = this;
            let uploadName = "mapFileUploder";
            let uploader = $(`body input:file[name=${uploadName}]:last`);
            if (!uploader || uploader.length < 1) {
                $("body").append(`<input name="${uploadName}" type="file" accept=".txt,.cad"></input>`);
                uploader = $(`body input:file[name=${uploadName}]:last`);
                uploader.on("change", (e: JQuery.TriggeredEvent) => {
                    let sender = $(e.currentTarget) as any;
                    if (sender && sender.length == 1 && sender[0].files.length == 1) {
                        let fileName = sender[0].files[0].name;
                        if (fileName.match(/\.txt$/)) {
                            let formData = new FormData();
                            formData.append('file', sender[0].files[0]);
                            sender.val("");
                            $.ajax({
                                url: getPathToActionMethod("LoadCadIdentifiers", "Map", { useArea: false }),
                                type: 'POST',
                                data: formData,
                                processData: false,  // tell jQuery not to process the data
                                contentType: false,  // tell jQuery not to set contentType,
                                enctype: 'multipart/form-data',
                                success: () => {
                                    self.showSelectionListResult();
                                }
                            });
                        }
                        else {
                            let formData = new FormData();
                            formData.append('fileInput', sender[0].files[0]);
                            let projection = "EPSG:3857";

                            sender.val("");
                            $.ajax({
                                url: `${globalVariables.uploadFileApiUrl}/data/Upload`,
                                type: 'POST',
                                data: formData,
                                processData: false,  // tell jQuery not to process the data
                                contentType: false,  // tell jQuery not to set contentType,
                                enctype: 'multipart/form-data',
                                global: false,
                                success: (data) => {
                                    if (data["success"] == true) {
                                        let layerExtent = data["extent"] as number[];
                                        if (layerExtent) {
                                            let viewProjection = self.map.getView().getProjection().getCode();
                                            if (projection && projection != viewProjection) {
                                                layerExtent = transformExtent(layerExtent, projection, viewProjection);
                                            }

                                            self.zoomToExtent(layerExtent);
                                        }

                                        let legendItems = data["legendItems"] as UploadFileLegendItem[];
                                        let legendItem = legendItems && legendItems.length == 1 ? legendItems[0] : null;
                                        if (legendItem && legendItem.children && legendItem.children.length > 0) {
                                            let layers = legendItem.children.map(
                                                item => <any>{
                                                    name: item.objDescName,
                                                    title: item.text
                                                });

                                            let layerCollection = self.map.getLayers();
                                            let index = layerCollection.getArray().findLastIndex(l => l.getProperties()["skipFromLegend"] == true);
                                            layerCollection.
                                                insertAt(
                                                    index + 1,
                                                    new ImageLayer(
                                                        {
                                                            extent: layerExtent,
                                                            source: new ImageWMS({
                                                                url: `${globalVariables.uploadFileApiUrl}/services/wms`,
                                                                params: {
                                                                    layers: layers.map(item => item["name"]).join(','),
                                                                    transparent: true
                                                                },
                                                                ratio: 1,
                                                                projection: projection
                                                            }),
                                                            properties: {
                                                                name: legendItem.mapName,
                                                                layers: layers,
                                                                removable: true
                                                            },
                                                            visible: true
                                                        })
                                                );
                                        }
                                    }
                                    else {
                                        let message = data["success"] ? data["success"] : getResource("UploadFileError");
                                        displayMessage(message, messageType.warning);
                                    }
                                },
                                error: () => {
                                    displayMessage(getResource("UploadFileError"), messageType.warning);
                                }
                            });
                        }
                    }
                });
            }

            uploader.trigger("click");
        });
        rebindEvent("change", "#mapPrintTemplate", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let sender = $(e.currentTarget).data("kendoDropDownList") as kendo.ui.DropDownList;
            let senderVal = sender.value();
            let widthInput = $("#mapPrintWidth");
            let heightInput = $("#mapPrintHeight");
            let unitRadioGroup = $("#mapPrintUnits").data("kendoRadioGroup");
            let disabledAttribute = "disabled";
            if (senderVal === "MAP_ONLY") {
                widthInput.removeAttr(disabledAttribute);
                heightInput.removeAttr(disabledAttribute);
                unitRadioGroup.enable(true);
            } else {
                widthInput.attr(disabledAttribute, "disabled");
                heightInput.attr(disabledAttribute, "disabled");
                unitRadioGroup.enable(false);
            }
        });
        rebindEvent("blur change", "#mapPrintWidth", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let sender = $(e.currentTarget);
            let inputVal = Number(sender.val());
            let unitRadioGroupVal = $("#mapPrintUnits").data("kendoRadioGroup")!.value();
            let isInInches = unitRadioGroupVal == "2";
            let minWidthAllowed = this.getMapPrintDimensionValueConverted(isInInches, globalVariables.mapExportMinWidthInCm);
            let maxWidthAllowed = this.getMapPrintDimensionValueConverted(isInInches, globalVariables.mapExportMaxWidthInCm);
            let inputValFormatted = this.getMapPrintDimensionValueFormatted(isInInches, inputVal);
            if (inputVal < minWidthAllowed) {
                sender.val(minWidthAllowed);
            }
            else if (inputVal > maxWidthAllowed) {
                sender.val(maxWidthAllowed);
            }
            else if (inputVal != inputValFormatted) {
                sender.val(inputValFormatted);
            }
        });
        rebindEvent("blur change", "#mapPrintHeight", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let sender = $(e.currentTarget);
            let inputVal = Number(sender.val());
            let unitRadioGroupVal = $("#mapPrintUnits").data("kendoRadioGroup")!.value();
            let isInInches = unitRadioGroupVal == "2";
            let minHeightAllowed = this.getMapPrintDimensionValueConverted(isInInches, globalVariables.mapExportMinHeightInCm);
            let maxHeightAllowed = this.getMapPrintDimensionValueConverted(isInInches, globalVariables.mapExportMaxHeightInCm);
            let inputValFormatted = this.getMapPrintDimensionValueFormatted(isInInches, inputVal);
            if (inputVal < minHeightAllowed) {
                sender.val(minHeightAllowed);
            }
            else if (inputVal > maxHeightAllowed) {
                sender.val(maxHeightAllowed);
            }
            else if (inputVal != inputValFormatted) {
                sender.val(inputValFormatted);
            }
        });
        rebindEvent("change", "#mapPrintUnits", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let unitRadioGroupVal = $("#mapPrintUnits").data("kendoRadioGroup")!.value();
            let isInInches = unitRadioGroupVal == "2";

            let heightTarget = $("#mapPrintHeight");
            let minHeightAllowed = this.getMapPrintDimensionValueConverted(isInInches, globalVariables.mapExportMinHeightInCm);
            heightTarget.val(minHeightAllowed);

            let widthTarget = $("#mapPrintWidth");
            let minWidthAllowed = this.getMapPrintDimensionValueConverted(isInInches, globalVariables.mapExportMinWidthInCm);
            widthTarget.val(minWidthAllowed);
        });
        rebindEvent("click", "#mapPrintSubmit", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let templateVal = $("#mapPrintTemplate").data("kendoDropDownList")!.value();
            let widthTarget = $("#mapPrintWidth");
            let heightTarget = $("#mapPrintHeight");
            let unitRadioGroupVal = $("#mapPrintUnits").data("kendoRadioGroup")!.value();
            let isInInches = unitRadioGroupVal == "2";
            let widthInputVal = isInInches ? Math.abs(Math.round(Number(widthTarget.val()) * 2.54 * 100) / 100) : Math.abs(Math.floor(Number(widthTarget.val())));
            let heightInputVal = isInInches ? Math.abs(Math.round(Number(heightTarget.val()) * 2.54 * 100) / 100) : Math.abs(Math.floor(Number(heightTarget.val())));

            let self = this;
            const extent = self.getExtent().Extent;
            const projection = self.getExtent().Projection;
            const wkid = projection.split(":")[1];
            const scale = self.getScale();
            const width = widthInputVal * 100;
            const height = heightInputVal * 100;
            const baseMapLayers = self.createBaseMapLayersForMapExport();
            const showAttribution = self.defineShowAttributionForMapExport(baseMapLayers);
            const operationalLayers = self.createOperationalLayersForMapExport();

            const payload = {
                Web_Map_as_JSON: self.constructWebMapAsJson(showAttribution, width, height, scale, extent, wkid, operationalLayers, baseMapLayers),
                Format: "PDF",
                Layout_Template: templateVal,
                f: "json",
            }
            handleMapExport(JSON.stringify(payload));
        });
        rebindEvent("click", ".zoom-to-all-js", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let sender = $(e.currentTarget);
            requestOptional(
                "ZoomToCartObjects",
                "Map",
                {
                    type: "GET",
                    data: {
                        key: sender.data("key")
                    },
                    success: (data: ZoomGeometry[]) => {
                        if (data && data.length > 0) {
                            let extent_ = createEmpty();
                            let features = data.map(geomData => {
                                return self.createFeatureFromZoomGeometry(geomData);
                            });
                            let selectionSource = self.selectionLayer.getSource();
                            selectionSource.clear(true);
                            features.forEach(feature => {
                                selectionSource.addFeature(feature);
                                extend(extent_, feature.getGeometry().getExtent());
                            });
                            self.zoomToExtent(extent_);
                        }
                    }
                });
        });
        rebindEvent("click", ".load-project-js", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let self = this;
            self.updateProjectObjectFilter($(e.currentTarget).data("id"));
        });
        rebindEvent("click", ".load-history-js", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let self = this;
            self.updateHistoryMoment($(e.currentTarget).data("historicmoment") as number);
        });
        rebindEvent("click", ".zoom-to-extent-js", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let self = this;
            let sender = $(e.currentTarget);
            let dropDownList = sender.closest(".form-input").find("input[data-role=\"dropdownlist\"]").data("kendoDropDownList") as kendo.ui.DropDownList;
            let dataItem = dropDownList ? dropDownList.dataItem() : null;
            let extent = dataItem ? dataItem.toJSON()["Extent"] as number[] : null;
            if (!extent || extent.length != 4) {
                return;
            }

            self.zoomToExtent(extent, "EPSG:7801");
        });
        rebindEvent("change", "#CoastCadRegisterType", (e: JQuery.TriggeredEvent) => {
            e.preventDefault();
            let sender = $(e.currentTarget)
            let form = sender.closest("form");
            let specmapComponent = form.find(".form-input.fullwidth.specmap");
            let zoneComponent = form.find(".form-input.fullwidth.zone");
            let value = sender.data("kendoDropDownList").value();
            if (value == "2") {
                specmapComponent?.hide();
                zoneComponent?.show();
            } else {
                specmapComponent?.show();
                zoneComponent?.hide();
            }
        });
    }

    private createFeatureFromZoomGeometry(data: ZoomGeometry): Feature {
        let self = this;
        let format = self.getFeatureFormat(data.Format);
        let isEsriJson = data.Format && data.Format.toLowerCase() === "esrijson";
        if (data.Geometry.hasOwnProperty(["points"]) && isEsriJson) {
            const points = data.Geometry["points"];
            const coord = new Array<Array<number>>();
            (points || []).forEach(p => {
                if (!isNaN(Number(p["x"])) && !isNaN(Number(p["y"]))) {
                    coord.push([Number(p["x"]), Number(p["y"])]);
                }
            })
            return new Feature({ geometry: new MultiPoint(coord) })
        } else {
            let projection = data.SpatialReferenceCode ? `EPSG:${data.SpatialReferenceCode}` : null;
            let options = self.getReadFeatureGeometryOptions(data.SpatialReferenceCode, isEsriJson && projection === self.sampleEtkProjection ? format : null);
            return new Feature(format.readGeometry(data.Geometry, options));
        }
    }

    private getMapPrintDimensionValueConverted(isInInches: boolean, value: string | number) {
        return isInInches ? Math.abs(Math.round(Number(value) / 2.54 * 100) / 100) : Math.abs(Math.floor(Number(value)));
    }

    private getMapPrintDimensionValueFormatted(isInInches: boolean, value: number) {
        return isInInches ? Math.abs(Math.round(value * 100) / 100) : Math.abs(Math.floor(value));
    }

    private getSampleEtkExpentInput() {
        return {
            inputTop: +$("#extentInputTop").val(),
            inputLeft: +$("#extentInputLeft").val(),
            inputRight: +$("#extentInputRight").val(),
            inputBottom: +$("#extentInputBottom").val()
        }
    }

    private sampleEtkValidationMsg(inputTop: number, inputLeft: number, inputRight: number, inputBottom: number) {
        const height = inputTop - inputBottom;
        const width = inputLeft - inputRight;
        let widthMessageEl = $(".etk-width-message");
        let heightMessageEl = $(".etk-height-message");
        if (height <= 0 || inputTop <= 0 || inputBottom <= 0) {
            heightMessageEl!.hasClass("etk-success-message") ? heightMessageEl.removeClass("etk-success-message") : "";
            heightMessageEl!.val(getResource("HeightGreater5000m"));
        }
        if (width <= 0 || inputLeft <= 0 || inputRight <= 0) {
            widthMessageEl!.hasClass("etk-success-message") ? widthMessageEl.removeClass("etk-success-message") : "";
            widthMessageEl!.val(getResource("WidthGreater5000m"));
        }
        if (height > 5000 && inputTop > 0 && inputBottom > 0) {
            heightMessageEl!.hasClass("etk-success-message") ? heightMessageEl.removeClass("etk-success-message") : "";
            heightMessageEl!.val(getResource("HeightUnder5000m"));
        }
        if (width > 5000 && inputLeft > 0 && inputRight > 0) {
            widthMessageEl!.hasClass("etk-success-message") ? widthMessageEl.removeClass("etk-success-message") : "";
            widthMessageEl!.val(getResource("WidthUnder5000m"));
        }
        if (height > 0 && height <= 5000 && inputTop > 0 && inputBottom > 0) {
            heightMessageEl!.addClass("etk-success-message").val(`${getResource("Height")} ${height} ${getResource("meter")}`);
        }
        if (width > 0 && width <= 5000 && inputLeft > 0 && inputRight > 0) {
            widthMessageEl!.addClass("etk-success-message").val(`${getResource("Width")} ${width} ${getResource("meter")}`);
        }
    }

    private isValidSampleEtkExtent(inputTop: number, inputBottom: number, inputLeft: number, inputRight: number): boolean {
        const height = inputTop - inputBottom;
        const width = inputLeft - inputRight;

        const isPositive = inputTop > 0 && inputBottom > 0 && inputLeft > 0 && inputRight > 0;
        const isHeightValid = height > 0 && height <= 5000;
        const isWidthValid = width > 0 && width <= 5000;

        return isPositive && isHeightValid && isWidthValid;
    }

    private getFeaturesFromDataSource(dataSource, selectedCSValue) {
        let features = [];
        for (let i = 0; i < dataSource.length; i++) {
            if (!isNaN(Number(dataSource[i].XLabel)) && !isNaN(dataSource[i].YLabel)) {
                let feature = this.createFeatureFromCoordinates(dataSource[i].XLabel, dataSource[i].YLabel, selectedCSValue);
                features.push(feature);
            } else {
                displayMessage(getResource("InvalidCoordinates"), messageType.error);
            }
        }
        return features;
    }

    private createBaseMapLayersForMapExport() {
        const baseMapLayers = new Array<BaseMapLayer>;
        let self = this;
        let baseMapGroupLayer = self.getLayerByName("base") as GroupLayer;
        baseMapGroupLayer?.getLayers().forEach(l => {
            let props = l.getProperties();
            if (props["source"] instanceof OSM && l.getVisible()) {
                const basemap: BaseMapLayer = {
                    id: "Basemap_Open_Street_Map",
                    layerType: "OpenStreetMap",
                    opacity: 1.0,
                    showLegend: false,
                    title: "Base Map",
                    visibility: true,
                    minScale: 2181466,
                    maxScale: 1128
                };
                let scale = self.getScale();
                if (scale >= basemap.maxScale && scale <= basemap.minScale) {
                    baseMapLayers.push(basemap);
                }
            }
        });
        return baseMapLayers;
    }

    private defineShowAttributionForMapExport(basemapLayers: BaseMapLayer[]) {
        return basemapLayers.length > 0;
    }

    private getLayersAllowedForMapExport() {
        let self = this;
        let defaultLayersNames = self.getDefaultLayersNames();
        defaultLayersNames.push(this.drawingLayerName);
        defaultLayersNames.push(this.selctionLayerName);

        let allLayers = self.map.getAllLayers();
        return (allLayers || []).filter((layer) => defaultLayersNames.indexOf(layer.getProperties()["id"]) !== -1 || defaultLayersNames.indexOf(layer.getProperties()["name"]) !== -1);
    }

    private createOperationalLayersForMapExport() {
        let self = this;
        let operationalLayers = new Array<OperationalLayer>();

        let filteredLayers = self.getLayersAllowedForMapExport();
        filteredLayers.forEach((l: Layer) => {
            const name = l.get("name");
            const source = l.get("source");
            let url = source["url_"];
            const urls: Array<string> | undefined = source["urls"];
            const operLayer: OperationalLayer = {
                id: name,
                title: name,
                opacity: 1,
                minScale: 0,
                maxScale: 0,
                url: "",
            }
            if (name && name !== "osm") {
                if (l.getVisible()) {
                    if (url) {
                        operLayer.url = url;
                        const params = source["params_"];
                        const paramsLayers = params["layers"] as string;
                        const paramsLayerDefs = params["layerDefs"] as string;
                        const paramsHistoricMoment = params["historicMoment"] as number;
                        if (paramsLayers) {
                            const paramsLayersArr = paramsLayers.split(":");
                            if (paramsLayersArr.length > 1) {
                                operLayer.visibleLayers = [];
                                const ids = paramsLayersArr[1].split(",");
                                ids.forEach(id => {
                                    if (!isNaN(Number(id)) && id !== "-1")
                                        operLayer.visibleLayers.push(Number(id))
                                });
                            }
                        };
                        if (paramsLayerDefs) {
                            let layers = [];
                            const layerDefs = JSON.parse(paramsLayerDefs);
                            for (var layerId in layerDefs) {
                                if (layerDefs.hasOwnProperty(layerId)) {
                                    layers.push({
                                        id: layerId,
                                        layerDefinition: {
                                            "definitionExpression": layerDefs[layerId]
                                        }
                                    });
                                }
                            }
                            if (layers.length) {
                                operLayer['layers'] = layers;
                            }
                        }
                        if (operLayer.id === "cadastreHistory" && (paramsHistoricMoment || paramsHistoricMoment === 0)) {
                            operLayer["customParameters"] = { "historicMoment": paramsHistoricMoment };
                        }

                        operationalLayers.push(operLayer);

                    } else if (urls && urls.length > 0) {
                        let _url = urls[0];
                        if (_url.indexOf('/tile/{z}/{y}/{x}') !== -1) {
                            // remove url tiles info
                            _url = _url.replace('/tile/{z}/{y}/{x}', '');
                        }
                        operLayer.url = _url;
                        operationalLayers.push(operLayer);
                    } else {
                        const features = source.getFeatures && source.getFeatures() || [];
                        const featureGroups = features.reduce((acc, curr) => {
                            const geom = curr.getGeometry();
                            const geomType = geom && geom.getType();
                            if (geomType) {
                                if (acc[geomType]) {
                                    acc[geomType].push(curr);
                                } else {
                                    acc[geomType] = [curr];
                                }
                            }
                            return acc;
                        }, {});
                        const opLyrCollections: any[] = Object.keys(featureGroups).map(featGroupKey => {
                            const targetFeatures = featureGroups[featGroupKey];
                            const geometryType = self.getGeometryType(featGroupKey);
                            return {
                                layerDefinition: {
                                    name: `${name} - ${featGroupKey}`,
                                    geometryType: geometryType
                                },
                                featureSet: {
                                    features: targetFeatures.map(f => {

                                        const geom = f.getGeometry();
                                        const coords = geom && geom.getCoordinates() || [];
                                        if (featGroupKey === 'Polygon') {
                                            return {
                                                geometry: {
                                                    rings: coords,
                                                    spatialReference: { wkid: 7801 }
                                                },
                                                "symbol": {
                                                    "type": "esriSFS",
                                                    "style": "esriSFSSolid",
                                                    "color": [
                                                        0,
                                                        0,
                                                        123,
                                                        51
                                                    ],
                                                    "outline": {
                                                        "type": "esriSLS",
                                                        "color": [
                                                            0,
                                                            0,
                                                            255
                                                        ],
                                                        "width": 2,
                                                        "style": "esriSLSSolid"
                                                    }
                                                }
                                            }
                                        } else if (featGroupKey === 'Point') {
                                            return {
                                                geometry: {
                                                    x: coords[0],
                                                    y: coords[1],
                                                    spatialReference: { wkid: 7801 }
                                                },
                                                "symbol": {
                                                    "type": "esriSMS",
                                                    "style": "esriSMSCircle",
                                                    "size": 20,
                                                    "color": [
                                                        0,
                                                        0,
                                                        123,
                                                        128
                                                    ],
                                                }
                                            }
                                        } else if (featGroupKey === 'LineString') {
                                            return {
                                                geometry: {
                                                    paths: [coords],
                                                    spatialReference: { wkid: 7801 }
                                                },
                                                "symbol": {
                                                    "type": "esriSLS",
                                                    "style": "esriSLSSolid",
                                                    "width": 2,
                                                    "color": [
                                                        0,
                                                        0,
                                                        255
                                                    ],
                                                }
                                            }
                                        }
                                    })
                                }
                            };
                        });

                        if (name === self.drawingLayerName && opLyrCollections.length) {
                            const coord = self.measureTooltip.getPosition();
                            const text = self.measureTooltip.getElement().innerText;
                            const textFeature = {
                                layerDefinition: {
                                    name: `${name} - textFeature`,
                                    geometryType: 'esriGeometryPoint'
                                },
                                featureSet: {
                                    features: [{
                                        geometry: {
                                            x: coord[0],
                                            y: coord[1],
                                            spatialReference: { wkid: 7801 }
                                        },
                                        "symbol": {
                                            "type": "esriTS",
                                            "color": [
                                                0,
                                                0,
                                                0,
                                                255
                                            ],
                                            "font": {
                                                "family": "Tahoma, sans-serif",
                                                "size": 10,
                                                "weight": "normal"
                                            },
                                            "text": text
                                        }
                                    }]
                                }
                            }
                            opLyrCollections.push(textFeature);
                        }

                        const collectionOpLayer = {
                            id: name,
                            featureCollection: {
                                layers: opLyrCollections
                            }
                        } as any;

                        operationalLayers = operationalLayers.concat(collectionOpLayer);
                    }
                }
            }
        });

        return operationalLayers;
    };

    private getGeometryType(geometryType: string) {
        if (geometryType === 'Polygon') {
            return 'esriGeometryPolygon';
        } else if (geometryType === 'Point') {
            return 'esriGeometryPoint';
        } else if (geometryType === 'LineString') {
            return 'esriGeometryPolyline';
        }
    }

    private constructWebMapAsJson(showAttribution: boolean, width: number, height: number, scale: number, extent: extent.Extent, wkid: string, operationalLayers: OperationalLayer[], basemapLayers: BaseMapLayer[]) {
        const webMapJson = {
            "mapOptions": {
                "showAttribution": showAttribution,
                "extent": {
                    "xmin": extent[0],
                    "ymin": extent[1],
                    "xmax": extent[2],
                    "ymax": extent[3],
                    "spatialReference": {
                        "wkid": wkid,
                    }
                },
                "spatialReference": {
                    "wkid": wkid,
                },
                "scale": scale
            },
            "baseMap": {
                "title": "Base Map",
                "baseMapLayers": basemapLayers,
            },
            "operationalLayers": operationalLayers,
            "exportOptions": {
                "outputSize": [width, height],
                "dpi": 300
            }
        }

        return JSON.stringify(webMapJson);
    }

    private createFeatureFromCoordinates(x: number, y: number, selectedCSValue: string) {
        let transfCoords = [y, x];
        if (selectedCSValue !== "1") {
            let view = this.map.getView();
            let baseMapProjection = view.getProjection().getCode();
            const sourceCoordinateSystem = this.getCoordinateSystem(selectedCSValue);
            let toCoordSystem = new Projection({
                code: sourceCoordinateSystem
            });

            transfCoords = transform([+y, +x], toCoordSystem, baseMapProjection);
        }

        let pointGeometry = new Point([
            transfCoords[0],
            transfCoords[1],
        ]);

        return new Feature({
            geometry: pointGeometry,
        });
    }

    private checkFileTypeFromName(fileName: string, targetType: string) {
        let re = new RegExp(`${targetType}$`, "g");
        return fileName.match(re);
    }

    private getCoordinateSystem = (csValue: string) => {
        switch (csValue) {
            case "1":
                return "EPSG:7801";

            case "2":
                return "EPSG:4326";

            case "3":
                return "EPSG:9391";

            case "4":
                return "EPSG:32634";

            case "5":
                return "EPSG:32635";

            default:
                return "EPSG:7801";
        }
    }

    private refreshResult = (condition: (listView: kendo.ui.ListView) => boolean = () => true) => {
        var resultListViews = $(".resultsList");
        if (resultListViews.length > 0) {
            resultListViews.each((index, item) => {
                let listView = $(item).data("kendoListView") as kendo.ui.ListView;
                if (listView && condition(listView)) {
                    listView.dataSource.read();
                }
            })
        }
    }

    private initProjection = () => {
        let self = this;
        let coordinateSystemControl = $("#coordinateSystem").data("kendoDropDownList") as kendo.ui.DropDownList;
        if (coordinateSystemControl) {
            coordinateSystemControl.bind("change", (e: kendo.ui.DropDownListChangeEvent) => {
                self.clientProjection = e.sender.value();
                self.clientProjectionName = e.sender.text();
                self.initCoordinates();
                self.initMousePosition();
            });
            coordinateSystemControl.trigger("change");
        }
    }

    private initMousePosition = () => {
        let self = this;
        let mousePositionControl = self.map.getControls().getArray().find(control => control instanceof MousePosition) as MousePosition;
        if (mousePositionControl) {
            mousePositionControl.setProjection(self.clientProjection);
        }
    }

    private initScale = () => {
        let self = this;
        let scaleControl = $("#scale").data("kendoNumericTextBox") as kendo.ui.NumericTextBox;
        if (scaleControl) {
            scaleControl.value(self.getScale());
        }
    }

    private getScale = (): number => {
        let self = this;
        let resolution = self.map.getView().getResolution();
        let scale = self.getScaleByResolution(resolution);
        return Math.round(scale);
    }

    private initCoordinates = () => {
        let self = this;
        if (!self.clientProjection) {
            return;
        }

        let view = self.map.getView();
        let coords = view.getCenter();
        let baseMapProjection = view.getProjection().getCode();
        let transfCoords = transform(coords, baseMapProjection, self.clientProjection);

        let xControl = $("#xCoordinate").data('kendoNumericTextBox') as kendo.ui.NumericTextBox;
        let yControl = $("#yCoordinate").data('kendoNumericTextBox') as kendo.ui.NumericTextBox;
        if (xControl && yControl) {
            xControl.value(transfCoords[1]);
            yControl.value(transfCoords[0]);
        }
    }

    private initLegend = () => {
        let self = this;
        self.legend = $("#legend").data("kendoTreeView") as kendo.ui.TreeView;
        self.legend.bind("check", self.onLegendCheck);
        self.legend.bind("expand", self.onLegendExpand);
        self.legendMenu = $("#legendMenu").data("kendoContextMenu") as kendo.ui.ContextMenu;
        self.legendMenu.bind("open", self.onLegendMenuOpen);
    }

    private getDefaulLayers = (): BaseLayer[] => {
        let self = this;
        const tileGridETK = self.getTileGridInfo("PNG32");
        const tileGridOrthophoto = self.getTileGridInfo("MIXED");
        return [
            new GroupLayer({
                properties: {
                    name: 'base',
                    skipFromLegend: true,
                },
                layers: [
                    new TileLayer({
                        properties: {
                            name: 'osm',
                            skipFromLegend: true
                        },
                        visible: false,
                        source: new OSM({
                            crossOrigin: "Anonymous",
                            url: globalVariables.osmUrl,
                        })
                    }),
                    new TileLayer({
                        properties: {
                            name: 'orthophoto_2011',
                            skipFromLegend: true
                        },
                        visible: false,
                        source: new OSM({
                            crossOrigin: null,
                            url: globalVariables.basemap11Url,
                            attributions: 'Map Tiles &copy; ' + new Date().getFullYear() + ' ' + '<a href="http://gis.mrrb.government.bg">МРРБ</a>'
                        })
                    }),
                    self.createBasemapBasedOnSourceConfiguration(globalVariables.basemap19Source, 'orthophoto_2019', globalVariables.basemap19Url, tileGridOrthophoto),
                    self.createBasemapBasedOnSourceConfiguration(globalVariables.basemap22Source, 'orthophoto_2022', globalVariables.basemap22Url, tileGridOrthophoto),
                    self.createBasemapBasedOnSourceConfiguration(globalVariables.gkfPublicEtkPreviewSource, 'GKF_ETK_Preview', globalVariables.gkfPublicEtkPreviewUrl, tileGridETK),
                ]
            }),
            new ImageLayer({
                source: new ImageArcGISRest({
                    url: globalVariables.administrativeUrl,
                    ratio: 1,
                }),
                visible: false,
                properties: {
                    name: 'administrative',
                },
            }),
            new ImageLayer({
                source: new ImageArcGISRest({
                    url: globalVariables.aisOfficesUrl,
                    ratio: 1,
                }),
                visible: false,
                properties: {
                    name: 'aisOffices',
                },
            }),
            new ImageLayer({
                source: new ImageArcGISRest({
                    url: globalVariables.coastCadPublicUrl,
                    ratio: 1,
                }),
                visible: false,
                properties: {
                    name: 'blackSeaCoast',
                    id: ArcGisGroupLayers.COAST_CAD,
                },
            }),
            new ImageLayer({
                source: new ImageArcGISRest({
                    url: globalVariables.gkfPublicDataUrl,
                    ratio: 1,
                }),
                visible: false,
                properties: {
                    name: 'geoKartFond',
                    id: ArcGisGroupLayers.GKF,
                },
            }),
            new ImageLayer({
                source: new ImageArcGISRest({
                    url: globalVariables.unapprovedCadastreUrl,
                    ratio: 1,
                    params: {
                        layerDefs: JSON.stringify(self.restrictionFilters[1])
                    }
                }),
                visible: false,
                properties: {
                    name: 'unapprovedCadastre',
                },
            }),
            self.createCadLayerBasedOnTypeConfiguration(globalVariables.buildingsCacheType, 'TileLayer_Buildings', globalVariables.buildingsCacheUrl),
            new ImageLayer({
                source: new ImageArcGISRest({
                    url: globalVariables.cadastreUrl,
                    ratio: 1,
                    params: {
                        layerDefs: JSON.stringify(self.restrictionFilters[0])
                    }
                }),
                visible: false,
                properties: {
                    name: 'cadastre'
                },
            }),
            self.createCadLayerBasedOnTypeConfiguration(globalVariables.parcelsCacheType, 'TileLayer_Parcels', globalVariables.parcelsCacheUrl),
            self.createCadLayerBasedOnTypeConfiguration(globalVariables.boundariesCacheType, 'TileLayer_Borders', globalVariables.boundariesCacheUrl),
            new ImageLayer({
                source: new ImageArcGISRest({
                    url: globalVariables.cadProjectsUrl,
                    ratio: 1
                }),
                visible: false,
                properties: {
                    name: self.projectLayersData[0].name,
                },
            }),
            new ImageLayer({
                source: new ImageArcGISRest({
                    url: globalVariables.cadastreHistoryUrl,
                    ratio: 1,
                    params: {
                        historicMoment: self.cadHistoryMinDate.valueOf()
                    }
                }),
                visible: false,
                properties: {
                    name: self.cadastreHistoryLayersData[0].name,
                    minDate: self.cadHistoryMinDate
                },
            }),
            new ImageLayer({
                source: new ImageArcGISRest({
                    url: globalVariables.geoNamesUrl,
                    ratio: 1,
                }),
                visible: false,
                properties: {
                    name: 'geoNames',
                },
            }),
            new ImageLayer({
                source: new ImageArcGISRest({
                    url: globalVariables.naturaUrl,
                    ratio: 1,
                }),
                visible: false,
                properties: {
                    name: 'naturaMap',
                },
            }),
            new ImageLayer(
                {
                    source: new ImageWMS({
                        url: globalVariables.executiveForestAgencyUrl,
                        params: {
                            transparent: true,
                        },
                        ratio: 1,
                    }),
                    properties: {
                        legendLayers: "IAG:dleso_full",
                        name: "executiveForestAgenc",
                    },
                    visible: false
                }),
            new GroupLayer({
                properties: {
                    "name": "group_drawing",
                    skipFromLegend: true
                },
                layers: [
                    new VectorLayer({
                        properties: {
                            name: self.drawingLayerName,
                            skipFromLegend: true
                        },
                        source: new Vector(),
                        style: self.drawingStyle
                    }),
                    new VectorLayer({
                        properties: {
                            name: self.selctionLayerName,
                            skipFromLegend: true
                        },
                        source: new Vector(),
                        style: self.drawingStyle
                    }),
                ]
            }),
        ];
    }

    private getDefaultLayersNames = (): string[] => {
        let self = this;
        const layers = self.getDefaulLayers();
        const names = new Array<string>();
        if (layers && layers.length) {
            layers.forEach((l: BaseLayer) => {
                let lname = l.getProperties()["name"];
                if (lname && names.indexOf(lname) === -1) {
                    names.push(lname);
                }
                let subLayers = l.getLayersArray();
                if (subLayers.length) {
                    subLayers.forEach((l) => {
                        let sublname = l.getProperties()["name"];
                        if (sublname && names.indexOf(sublname) === -1) {
                            names.push(sublname);
                        }
                    })
                }
            })
        }
        return names;
    }

    private getAproximateResolutionByScale = (scale: number) => {
        return scale / 39.37 / this.dpi;
    }

    private getTileGridInfo = (format: string) => {
        const serviceInfo = {
            "tileInfo": {
                "rows": 256,
                "cols": 256,
                "dpi": 96,
                "format": format,
                "compressionQuality": 0,
                "origin": {
                    "x": -36179500,
                    "y": 48335300
                },
                "lods": [
                    {
                        "level": 0,
                        "resolution": 793.7515875031751,
                        "scale": 3000000
                    },
                    {
                        "level": 1,
                        "resolution": 264.5838625010584,
                        "scale": 1000000
                    },
                    {
                        "level": 2,
                        "resolution": 132.2919312505292,
                        "scale": 500000
                    },
                    {
                        "level": 3,
                        "resolution": 52.91677250021167,
                        "scale": 200000
                    },
                    {
                        "level": 4,
                        "resolution": 26.458386250105836,
                        "scale": 100000
                    },
                    {
                        "level": 5,
                        "resolution": 13.229193125052918,
                        "scale": 50000
                    },
                    {
                        "level": 6,
                        "resolution": 5.291677250021167,
                        "scale": 20000
                    },
                    {
                        "level": 7,
                        "resolution": 2.6458386250105836,
                        "scale": 10000
                    },
                    {
                        "level": 8,
                        "resolution": 1.3229193125052918,
                        "scale": 5000
                    },
                    {
                        "level": 9,
                        "resolution": 0.5291677250021167,
                        "scale": 2000
                    },
                    {
                        "level": 10,
                        "resolution": 0.26458386250105836,
                        "scale": 1000
                    },
                    {
                        "level": 11,
                        "resolution": 0.13229193125052918,
                        "scale": 500
                    }
                ]
            }
        };

        const _origin = [
            serviceInfo.tileInfo.origin.x,
            serviceInfo.tileInfo.origin.y,
        ];

        const resolutions = serviceInfo.tileInfo.lods.map(l => l.resolution);
        const tileSize = [serviceInfo.tileInfo.cols, serviceInfo.tileInfo.rows];
        return new TileGrid({
            origin: _origin,
            resolutions: resolutions,
            tileSize: tileSize,
        });
    }

    private createBasemapBasedOnSourceConfiguration = (source: string, name: string, sourceUrl: string, tileGrid: TileGrid) => {
        if (source && source === "XYZ") {
            return new TileLayer({
                properties: {
                    name: name,
                    skipFromLegend: true,
                    id: name,
                },
                visible: false,
                source: new XYZ({
                    url: sourceUrl + '/tile/{z}/{y}/{x}',
                    tileGrid: tileGrid,
                    projection: 'EPSG:7801'
                })
            })
        }
        return new TileLayer({
            properties: {
                name: name,
                skipFromLegend: true,
                id: name
            },
            visible: false,
            source: new TileArcGISRest({
                url: sourceUrl,
            })
        })
    }

    private createCadLayerBasedOnTypeConfiguration = (type: string, name: string, sourceUrl: string) => {
        let self = this;
        if (type && type === "ImageLayer") {
            return new ImageLayer({
                properties: {
                    name: name,
                    skipFromLegend: true,
                    id: name
                },
                visible: false,
                source: new ImageArcGISRest({
                    url: sourceUrl,
                })
            })
        }
        return new TileLayer({
            properties: {
                name: name,
                skipFromLegend: true,
                id: name,
            },
            visible: false,
            source: new XYZ({
                url: sourceUrl + '/tile/{z}/{y}/{x}',
                tileGrid: self.getTileGridInfoForCadLayers(),
                projection: 'EPSG:7801'
            }),
            maxResolution: self.getAproximateResolutionByScale(5500),
            minResolution: self.getAproximateResolutionByScale(250)
        })
    }

    private getTileGridInfoForCadLayers = () => {
        const serviceInfo = {
            "tileInfo": {
                "rows": 256,
                "cols": 256,
                "dpi": 96,
                "origin": {
                    "x": -36179500,
                    "y": 48335300
                },
                "lods": [
                    {
                        "level": 0,
                        "resolution": 793.7515875031751,
                        "scale": 3000000
                    },
                    {
                        "level": 1,
                        "resolution": 264.5838625010584,
                        "scale": 1000000
                    },
                    {
                        "level": 2,
                        "resolution": 132.2919312505292,
                        "scale": 500000
                    },
                    {
                        "level": 3,
                        "resolution": 52.91677250021167,
                        "scale": 200000
                    },
                    {
                        "level": 4,
                        "resolution": 26.458386250105836,
                        "scale": 100000
                    },
                    {
                        "level": 5,
                        "resolution": 13.229193125052918,
                        "scale": 50000
                    },
                    {
                        "level": 6,
                        "resolution": 5.291677250021167,
                        "scale": 20000
                    },
                    {
                        "level": 7,
                        "resolution": 2.6458386250105836,
                        "scale": 10000
                    },
                    {
                        "level": 8,
                        "resolution": 1.3229193125052918,
                        "scale": 5000
                    },
                    {
                        "level": 9,
                        "resolution": 0.5291677250021167,
                        "scale": 2000
                    },
                    {
                        "level": 10,
                        "resolution": 0.26458386250105836,
                        "scale": 1000
                    },
                    {
                        "level": 11,
                        "resolution": 0.13229193125052918,
                        "scale": 500
                    },
                    {
                        "level": 12,
                        "resolution": 0.06614596562526459,
                        "scale": 250
                    }
                ]
            }
        }

        const _origin = [
            serviceInfo.tileInfo.origin.x,
            serviceInfo.tileInfo.origin.y,
        ];
        const resolutions = serviceInfo.tileInfo.lods.map(l => l.resolution);
        const tileSize = [serviceInfo.tileInfo.cols, serviceInfo.tileInfo.rows];
        return new TileGrid({
            origin: _origin,
            resolutions: resolutions,
            tileSize: tileSize,
        });
    }

    private getMapLayersDataSourceAsync = async (): Promise<LegendItem[]> => {
        let self = this;
        return await self.getLayersDataSourceAsync(self.map.getLayers().getArray());
    }

    private getLayersDataSourceAsync = async (layers: BaseLayer[]): Promise<LegendItem[]> => {
        let self = this;
        if (!layers || layers.length < 1) {
            return null;
        }

        let layersDataSource: LegendItem[] = [];
        for (let layer of layers) {
            let layerProperties = layer.getProperties();
            if (layerProperties['skipFromLegend'] === true) {
                continue;
            }

            let group = layer instanceof GroupLayer ? layer as GroupLayer : null;
            let items = group
                ? await self.getLayersDataSourceAsync(group.getLayers().getArray())
                : layer as Layer
                    ? await self.getLegendItemsForLayerAsync(layer as Layer)
                    : null;

            layersDataSource.unshift({
                name: layerProperties["name"],
                title: layerProperties["title"],
                checked: layer.getVisible(),
                items: items
            });
        }

        return layersDataSource;
    }

    private getLegendItemsForLayerAsync = async (layer: Layer): Promise<LegendItem[]> => {
        let self = this;
        if (!layer) {
            return null
        }

        let source = layer.getSource();
        if (!source) {
            return;
        }

        try {
            switch (source.constructor) {
                case TileWMS:
                case ImageWMS: {
                    return await self.getWmsLegendItemsAsync(source instanceof ImageWMS ? source as ImageWMS : source as TileWMS, layer);
                }

                case TileArcGISRest:
                case ImageArcGISRest: {
                    return await self.getArcGisLegendItemsAsync(source instanceof ImageArcGISRest ? source as ImageArcGISRest : source as TileArcGISRest, layer);
                }

                default:
                    return null;
            }
        } catch {
            let properties = layer.getProperties();
            console.warn(`${getResource("LoadLayerError")}: ${getResource(properties["name"])}`);
            return null;
        }
    }

    private getWmsLegendItemsAsync = async (source: ImageWMS | TileWMS, layer: Layer): Promise<LegendItem[]> => {
        let url = source instanceof ImageWMS ? source.getUrl() : source.getUrls[0];
        if (!url) {
            return null;
        }

        let key = url;
        let data = sessionStorage[key] ? JSON.parse(sessionStorage.getItem(key)) : null;
        if (!data || !data.hasOwnProperty("legendItems")) {
            let layerProperties = layer.getProperties();
            let layers = layerProperties["layers"] as any[];
            let callCapabilities = !layers || layers.length < 0;
            if (callCapabilities) {
                let d = await requestOptionalUrlAsync(
                    `${url}?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetCapabilities`,
                    {
                        type: "GET",
                        dataType: "xml",
                        global: false,
                        timeout: 1000
                    });

                if (d) {
                    let data = new WMSCapabilities().read(d);
                    if (data && data["Capability"] && data["Capability"]["Layer"] && data["Capability"]["Layer"]["Layer"]) {
                        layers = data["Capability"]["Layer"]["Layer"];
                        layer.setProperties({
                            "layers": layers
                        });
                    }
                }
            }

            let visible = layer.getVisible();
            let visibleLayersText = source.getParams()["layers"] as string;
            let visibleLayers = visibleLayersText ? visibleLayersText.split(',').map(item => item) : null;
            let legendLayersText = layerProperties["legendLayers"] as string;
            let legendLayers = legendLayersText ? legendLayersText.split(',').map(item => item) : null;
            let legendItems = layers?.filter(item => legendLayers ? legendLayers.indexOf(item["name"] ? item["name"] : item["Name"]) >= 0 : true)
                .map(item => {
                    let name = item["name"] ? item["name"] : item["Name"];
                    let title = item["title"] ? item["title"] : item["Title"];
                    return <LegendItem>{
                        checked: visible && visibleLayers && visibleLayers.indexOf(name) >= 0,
                        name: name,
                        title: title,
                        layerNameOnMap: layerProperties["name"],
                        items: [{
                            legend: source.getLegendUrl(null, { layer: name })
                        }]
                    };
                });

            if (legendItems) {
                data = {
                    extent: layer.getExtent(),
                    legendItems: legendItems
                };

                if (callCapabilities) {
                    sessionStorage.setItem(
                        key,
                        JSON.stringify(data));
                }
            }
        }

        if (data["extent"]) {
            layer.setExtent(data["extent"] as number[]);
        }

        return data["legendItems"] as LegendItem[];
    }

    private getArcGisLegendItemsAsync = async (source: ImageArcGISRest | TileArcGISRest, layer: Layer): Promise<LegendItem[]> => {
        let self = this;
        let layerProperties = layer.getProperties();
        let layerName: string = layerProperties["name"];
        let visible: boolean = layer.getVisible();
        let url = source instanceof ImageArcGISRest ? (source as ImageArcGISRest).getUrl() : (source as TileArcGISRest).getUrls()[0];
        if (!url) {
            return null;
        }
        let key = url;
        let data = sessionStorage[key] ? JSON.parse(sessionStorage.getItem(key)) : null;
        if (!data || !data.hasOwnProperty("legendItems")) {
            let legend: LegendItem[] = [];
            let d = await requestOptionalUrlAsync(
                `${url}/legend?f=pjson`,
                {
                    type: "GET",
                    dataType: "json",
                    global: false
                });

            if (d && d["layers"] && d.layers.length > 0) {
                for (let i = 0; i < d.layers.length; i++) {
                    d.layers[i]['legend']?.forEach((l, index) => {
                        legend.push({
                            parentLayerId: d.layers[i].layerId,
                            name: l['label'],
                            legend: `data:${l['contentType']};base64, ${l['imageData']}`
                        });
                    });
                }
            }

            let layers: LegendItem[] = null;
            d = await requestOptionalUrlAsync(
                `${url}?f=pjson`,
                {
                    type: "GET",
                    dataType: "json",
                    global: false
                });

            if (d && d["layers"] && d.layers.length > 0) {
                let layerExtent = d["fullExtent"];
                if (layerExtent) {
                    layer.setExtent([layerExtent["xmin"], layerExtent["ymin"], layerExtent["xmax"], layerExtent["ymax"]]);
                }

                layers = (d.layers).map((item) => <LegendItem>{
                    layerNameOnMap: layerName,
                    id: item["id"],
                    title: item["name"],
                    parentLayerId: item["parentLayerId"],
                    defaultVisibility: item["defaultVisibility"],
                    subLayerIds: item["subLayerIds"],
                    minScale: item["minScale"],
                    maxScale: item["maxScale"],
                    type: item["type"],
                    supportsDynamicLegends: item["supportsDynamicLegends"],
                    geometryType: item["geometryType"]
                });
            }

            if (layers && legend) {
                layers = layers.concat(legend);
            }

            data = {
                extent: layer.getExtent(),
                legendItems: layers ? this.legendArrayToTree(layers) : layers
            };
            sessionStorage.setItem(
                key,
                JSON.stringify(data));
        }

        if (data["extent"]) {
            layer.setExtent(data["extent"] as number[]);
        }

        let items = data["legendItems"] as LegendItem[];
        self.initArcGisSubLayersVisibility(items, visible);

        let showLayerIds = [];
        if (visible) {
            if (items && items.length > 0) {
                items.forEach(item => {
                    if (item.defaultVisibility == true && !isNaN(item.id) && !item.legend) {
                        if (item.subLayerIds) {
                            showLayerIds.push(...item.subLayerIds);
                        } else {
                            showLayerIds.push(item.id);
                        }
                    }
                })
            }
        }

        let filter = showLayerIds.length > 0 ? showLayerIds.join(',') : '-1';
        source.updateParams({
            layers: `show: ${filter}`
        })

        return items;
    }

    private initArcGisSubLayersVisibility(layers: LegendItem[], visible: boolean) {
        let self = this;
        if (!layers || layers.length < 0) {
            return;
        }

        layers.forEach((item, index) => {
            if (item.subLayerIds || item.legend) {
                return;
            }

            item.checked = visible == true && item.defaultVisibility == true;
            self.initArcGisSubLayersVisibility(item.items, visible);
        });
    }

    private legendArrayToTree = (arr: LegendItem[], parent: number = -1): LegendItem[] =>
        arr.filter(item => item.parentLayerId === parent).map(child => ({ ...child, items: !isNaN(child.id) ? this.legendArrayToTree(arr, child.id) : null })) as LegendItem[];

    private updateArcGisLayerVisibility = (legendItem: LegendItem, visible: boolean, layer: Layer, source: ImageArcGISRest | TileArcGISRest) => {
        let cadastreLayer = null;
        let self = this;
        let params = source ? source.getParams() : null;
        if (!params) {
            return;
        }

        let showLayerIds = params['layers']?.length
            ? params['layers'].split(':')[1].split(',').map(str => { return Number(str); }) as Array<number>
            : [];
        if (showLayerIds) {
            let items = self.findLegendItems([legendItem], item => item.id >= 0 && !item.legend && (!item.subLayerIds || item.subLayerIds.length < 1));
            if (items && items.length > 0) {
                for (let i = 0; i < items.length; i++) {
                    let id = items[i].id;

                    // handle cached tile layers ids
                    if (legendItem.layerNameOnMap === 'cadastre') {
                        if ([2, 15, 1].indexOf(id) !== -1) { // 17,
                            cadastreLayer = id;
                            continue;
                        }
                    }

                    let index = showLayerIds.indexOf(id);
                    if (visible && index < 0) {
                        showLayerIds.push(id);
                    }
                    else if (!visible && index >= 0) {
                        showLayerIds.splice(index, 1);
                    }
                }

                let negativeIndex = showLayerIds.indexOf(-1);
                if (negativeIndex >= 0) {
                    showLayerIds.splice(negativeIndex, 1);
                }
            }
        }

        // Use correct layers sort - use in info
        if (showLayerIds.length > 0) {
            let url = source instanceof ImageArcGISRest ? source.getUrl() : source.getUrls[0];
            let data = sessionStorage[url] ? JSON.parse(sessionStorage.getItem(url)) : null;
            if (data && data.hasOwnProperty("legendItems")) {
                let items = (data["legendItems"] as LegendItem[]).map(item => item.id);
                showLayerIds.sort((x, y) => items.indexOf(x) - items.indexOf(y));
            }
        }

        if (legendItem.layerNameOnMap === 'cadastre') {
            self.setTileLayersVisibility(cadastreLayer, visible);
        }

        let filter = showLayerIds.length > 0 ? showLayerIds.join(',') : '-1';
        source.updateParams({
            layers: `show: ${filter}`
        });

        let isLayerVisible = layer.getVisible();
        if (showLayerIds.length > 0) {
            if (!isLayerVisible) {
                layer.setVisible(true);
            }
        }
        else {
            if (isLayerVisible) {
                layer.setVisible(false);
            }
        }
    }

    private setTileLayersVisibility = (cadastreLayer: number, visible: boolean) => {
        var self = this;
        if (cadastreLayer === 2) {
            const tileLayerBuidlings = self.findLayers((layer) => layer.getProperties()["id"] === 'TileLayer_Buildings');
            if (tileLayerBuidlings[0]) {
                tileLayerBuidlings[0].setVisible(visible);
            }

        }
        else if (cadastreLayer === 15) {
            const tileLayerBorders = self.findLayers((layer) => layer.getProperties()["id"] === 'TileLayer_Borders');
            if (tileLayerBorders[0]) {
                tileLayerBorders[0].setVisible(visible);
            }
        }
        //else if (cadastreLayer === 17) {
        //    const tileLayerLabels = self.findLayers((layer) => layer.getProperties()["id"] === 'TileLayer_Labels');
        //    if (tileLayerLabels[0]) {
        //        tileLayerLabels[0].setVisible(visible);
        //    }
        //}
        else if (cadastreLayer === 1) {
            const tileLayerParcels = self.findLayers((layer) => layer.getProperties()["id"] === 'TileLayer_Parcels');
            if (tileLayerParcels[0]) {
                tileLayerParcels[0].setVisible(visible);
            }
        }
    }

    private updateWmsLayerVisibility = (legendItem: LegendItem, visible: boolean, layer: Layer, source: ImageWMS | TileWMS) => {
        let params = source ? source.getParams() : null;
        if (!params) {
            return;
        }

        let visibleLayers = params['layers']?.length
            ? params['layers'].split(',') as Array<string>
            : [];
        if (visibleLayers) {
            const index = visibleLayers.indexOf(legendItem.name);
            if (visible && index < 0) {
                visibleLayers.push(legendItem.name);
            }
            else if (!visible && index >= 0) {
                visibleLayers.splice(index, 1);
            }
        }

        source.updateParams({
            layers: visibleLayers.length > 0 ? visibleLayers.join(',') : ''
        });

        let isLayerVisible = layer.getVisible();
        if (visibleLayers.length > 0) {
            if (!isLayerVisible) {
                layer.setVisible(true);
            }
        }
        else {
            if (isLayerVisible) {
                layer.setVisible(false);
            }
        }
    }

    private onLegendCheck = (e: kendo.ui.TreeViewCheckEvent) => {
        let self = this;
        let dataItem = e.sender.dataItem(e.node);
        let visible = $(e.node).attr("aria-checked") != "false";
        let legendItem = dataItem.toJSON() as LegendItem;
        self.setLayerVisibilityByLegendItem(legendItem, visible);
    }

    private onLegendExpand = (e: kendo.ui.TreeViewExpandEvent) => {
        // Legend lazy loading
        let ulElement = $(e.node).children("ul");
        if (ulElement.find("ul").length === 0) {
            ulElement.find("img[data-src]").each((index, item) => {
                let img = $(item);
                let scr = img.attr('data-src');
                img.attr('src', scr);
                img.removeAttr('data-src');
            });
        }
    }

    private setLayerVisibilityByLegendItem = (legendItem: LegendItem, visible: boolean) => {
        let self = this;
        if (legendItem.legend) {
            return;
        }

        let baseLayer = self.getLayerByName(legendItem.layerNameOnMap ? legendItem.layerNameOnMap : legendItem.name);
        if (!baseLayer) {
            return;
        }

        if (legendItem.layerNameOnMap) {
            let layer = baseLayer as Layer;
            if (layer) {
                let source = layer.getSource();
                switch (source.constructor) {
                    case TileWMS:
                    case ImageWMS: {
                        self.updateWmsLayerVisibility(legendItem, visible, layer, source instanceof ImageWMS ? source as ImageWMS : source as TileWMS);
                        return;
                    }

                    case TileArcGISRest:
                    case ImageArcGISRest: {
                        self.updateArcGisLayerVisibility(legendItem, visible, layer, source instanceof ImageArcGISRest ? source as ImageArcGISRest : source as TileArcGISRest);
                        return;
                    }
                }
            }
        }
        else {
            self.setLayerVisibility(baseLayer, visible);
        }

        if (legendItem.items && legendItem.items.length > 0) {
            for (let i = 0; i < legendItem.items.length; i++) {
                self.setLayerVisibilityByLegendItem(legendItem.items[i], visible);
            }
        }
    }

    private setLayerVisibility = (layer: BaseLayer, visible: boolean) => {
        let self = this;
        if (!layer) {
            return;
        }

        // GroupLayer is always visible - do not change group layer visibility 
        if (layer instanceof GroupLayer) {
            let group = layer as GroupLayer;
            group.getLayers().forEach((item) => self.setLayerVisibility(item, visible));
        } else {
            layer.setVisible(visible);
        }
    }

    private getLayerByName = (layerName: string): BaseLayer => {
        let self = this;
        if (!layerName) {
            return;
        }

        let findLayers = self.findLayers((layer) => layer.getProperties()["name"] === layerName);
        return findLayers?.length > 0 ? findLayers[0] : null;
    }

    private onLegendMenuOpen = (e: kendo.ui.ContextMenuOpenEvent) => {
        let self = this;
        let legendItem = self.legend.dataItem(e.target) as LegendItem;
        let baseLayer = legendItem && legendItem.name ? self.getLayerByName(legendItem.name) : null;
        if (!baseLayer) {
            e.preventDefault();
            return;
        }

        let layerExtent = baseLayer.getExtent();
        e.sender.enable(".historicmoment-js", legendItem.name == this.cadastreHistoryLayersData[0].name);
        e.sender.enable(".zoom-js", layerExtent && layerExtent.length == 4);
        e.sender.enable(".remove-js", baseLayer.getProperties()["removable"] == true);
    }

    private findLayers = (filter: (l: BaseLayer) => boolean, dfs: boolean = true): BaseLayer[] => {
        let self = this;
        let layers: BaseLayer[] = [...self.map.getLayers().getArray()];
        let found: BaseLayer[] = [];
        while (layers.length > 0) {
            let layer = layers.shift();
            if (filter(layer)) {
                found.push(layer);
            }

            if (layer instanceof GroupLayer) {
                let groupLayers = (layer as GroupLayer).getLayers().getArray();
                if (dfs) {
                    layers.push(...groupLayers);
                }
                else {
                    layers.unshift(...groupLayers);
                }
            }
        }

        return found;
    }

    private findLegendItems = (data: LegendItem[], filter: (l: LegendItem) => boolean, dfs: boolean = true): LegendItem[] => {
        let items: LegendItem[] = data ? [...data] : [];
        let found: LegendItem[] = [];
        while (items.length > 0) {
            let item = items.shift();
            if (filter(item)) {
                found.push(item);
            }

            if (item.items && item.items.length > 0) {
                if (dfs) {
                    items.push(...item.items);
                }
                else {
                    items.unshift(...item.items);
                }
            }
        }

        return found;
    }

    private legendSearch = (filter: (l: LegendItem) => boolean): kendo.data.Node => {
        let self = this;
        return self.legendSearch2(self.legend.dataSource.data(), filter);
    }

    private legendSearch2 = (data: any, filter: (l: any) => boolean): kendo.data.Node => {
        let self = this;

        if (data && data.length > 0) {
            for (let i = 0; i < data.length; i++) {
                let item = data[i];
                if (filter(item)) {
                    return item;
                }

                if (item.hasChildren) {
                    let f = self.legendSearch2(item.children.data(), filter);
                    if (f) {
                        return f;
                    }
                }
            }
        }

        return null;
    }

    private getScaleByResolution = (resolution: number): number => {
        let self = this;
        let units = self.map.getView().getProjection().getUnits();
        return resolution * METERS_PER_UNIT[units] * 39.37 * self.dpi;
    }

    private getResolutionByScale = (scale: number): number => {
        let self = this;
        let units = self.map.getView().getProjection().getUnits();
        return scale / METERS_PER_UNIT[units] / 39.37 / self.dpi;
    }

    private getActiveLegendItem = (): LegendItem => {
        let self = this;
        let active = self.legend.element.find(`#${self.legend.element.attr("id")}_tv_active`);
        let item = self.legend.dataItem(active);
        return item ? item.toJSON() as LegendItem : null;
    }

    private changeScaleAndPanToCoordinates = () => {
        let self = this;
        let view = self.map.getView();
        let scaleControl = $("#scale").data("kendoNumericTextBox") as kendo.ui.NumericTextBox;
        let xControl = $("#xCoordinate").data('kendoNumericTextBox') as kendo.ui.NumericTextBox;
        let yControl = $("#yCoordinate").data('kendoNumericTextBox') as kendo.ui.NumericTextBox;
        let coord = [
            yControl.value(),
            xControl.value()
        ];

        let baseMapProjection = view.getProjection().getCode();
        let transformedCoords = transform(coord, self.clientProjection, baseMapProjection);
        view.animate({
            center: transformedCoords,
            resolution: self.getResolutionByScale(scaleControl.value())
        });
    }

    private zoomToExtent = (extent: extent.Extent | SimpleGeometry, projection: string = null) => {
        if (!extent) {
            return;
        }

        let self = this;
        let bbox: extent.Extent;
        if (extent instanceof SimpleGeometry) {
            bbox = extent.getExtent();
        }
        else {
            bbox = extent as extent.Extent;
        }

        let view = self.map.getView();
        let viewProjection = view.getProjection().getCode();
        if (projection && projection != viewProjection) {
            bbox = transformExtent(bbox, projection, viewProjection);
        }

        view.fit(
            bbox,
            {
                size: self.map.getSize(),
                duration: 1000,
                padding: [100, 70, 70, 70]
            });
    }

    private zoomToLayer = (layerName: string) => {
        let self = this;
        let baseLayer = layerName ? self.getLayerByName(layerName) : null;
        if (!baseLayer) {
            return;
        }

        self.zoomToExtent(baseLayer.getExtent());
    }

    private getInteractions = (): Interaction[] => {
        let self = this;
        let duration: number = 500;
        let interactions: Interaction[] = [];

        let zoomInTool = new DragZoom({
            duration: duration,
            condition: condition.noModifierKeys
        });
        zoomInTool.set(self.propertyKeyName, "zoomInTool");
        interactions.push(zoomInTool);

        let zoomOutTool = new DragZoom({
            duration: duration,
            condition: condition.noModifierKeys,
            out: true
        });
        zoomOutTool.set(self.propertyKeyName, "zoomOutTool");
        interactions.push(zoomOutTool);

        let panTool = new DragPan({
            condition: condition.noModifierKeys,
        });
        panTool.set(self.propertyKeyName, "panTool");
        interactions.push(panTool);

        let infoTool = new Interaction({
            handleEvent: (mapBrowserEvent: MapBrowserEvent<any>) => {
                let stopEvent = false;
                if (mapBrowserEvent.type == MapBrowserEventType.CLICK) {
                    let browserEvent = (
                        mapBrowserEvent.originalEvent
                    );

                    (async () => await self.getObjectInfoAsync(mapBrowserEvent.coordinate))();

                    browserEvent.preventDefault();
                    stopEvent = true;
                }
                return !stopEvent;
            }
        });
        infoTool.set(self.propertyKeyName, "infoTool");
        infoTool.set(self.propertyKeyActivateChange, self.onActiveChangeInfoTool);
        interactions.push(infoTool);

        let etkSelectionTool = new DragBox({
            condition: condition.noModifierKeys,
            className: "etk-dragbox",
            onBoxEnd: (mapBrowserEvent: MapBrowserEvent<KeyboardEvent | PointerEvent | WheelEvent>) => {
                let self = this;
                let extent = etkSelectionTool.getGeometry().getExtent();
                if (!extent) {
                    return;
                }
                let mapProjection = self.map.getView().getProjection();
                let targetProjection = new Projection({ code: self.sampleEtkProjection });
                let transformed = transformExtent(extent, mapProjection, targetProjection);
                if (!transformed) {
                    return;
                }
                $(".right").val(Math.trunc(transformed[0]));
                $(".bottom").val(Math.trunc(transformed[1]));
                $(".left").val(Math.trunc(transformed[2]));
                $(".top").val(Math.trunc(transformed[3]));
                let height = Math.abs(+$(".top").val() - +$(".bottom").val());
                let width = Math.abs(+$(".left").val() - +$(".right").val());
                let heightMessageEl = $(".etk-height-message");
                let widthMessageEl = $(".etk-width-message");
                if (height > 5000) {
                    heightMessageEl.hasClass("etk-success-message") ? heightMessageEl.removeClass("etk-success-message") : "";
                    heightMessageEl.val(getResource("HeightUnder5000m"));
                } else {
                    heightMessageEl.addClass("etk-success-message").val(`${getResource("Height")} ${height} ${getResource("meter")}`);
                }
                if (width > 5000) {
                    widthMessageEl.hasClass("etk-success-message") ? widthMessageEl.removeClass("etk-success-message") : "";
                    widthMessageEl.val(getResource("WidthUnder5000m"));
                } else {
                    widthMessageEl.addClass("etk-success-message").val(`${getResource("Width")} ${width} ${getResource("meter")}`);
                }
                etkSelectionTool.setActive(false);
            },
        });
        etkSelectionTool.set(self.propertyKeyName, "etkSelectionTool");
        interactions.push(etkSelectionTool);

        let selectionTool = new DragBox({
            condition: (evt) => { return !evt.originalEvent.altKey && !(evt.originalEvent.metaKey || evt.originalEvent.ctrlKey); },
            onBoxEnd: (mapBrowserEvent: MapBrowserEvent<KeyboardEvent | PointerEvent | WheelEvent>) => {
                let self = this;
                let extent = selectionTool.getGeometry().getExtent();
                let keyboardEvent = mapBrowserEvent.originalEvent as KeyboardEvent;
                self.selectObjects(extent, !(keyboardEvent && keyboardEvent.shiftKey))
            },
            minArea: 1
        });
        selectionTool.set(self.propertyKeyName, "selectionTool");
        selectionTool.set(self.propertyKeyActivateChange, self.onActiveChangeSelectionTool);
        interactions.push(selectionTool);

        let lineMeasureTool = new Draw({
            source: self.drawingLayer.getSource(),
            type: 'LineString',
            style: self.drawingStyle,
        });
        lineMeasureTool.set(self.propertyKeyName, "lineMeasureTool");
        lineMeasureTool.set(self.propertyKeyActivateChange, self.onActiveChangeMeasureTool);
        lineMeasureTool.on("drawstart", self.onMeasureDrawStart);
        lineMeasureTool.on("drawend", self.onMeasureDrawEnd);
        interactions.push(lineMeasureTool);

        let areaMeasureTool = new Draw({
            source: self.drawingLayer.getSource(),
            type: 'Polygon',
            style: self.drawingStyle
        });
        areaMeasureTool.set(self.propertyKeyName, "areaMeasureTool");
        areaMeasureTool.set(self.propertyKeyActivateChange, self.onActiveChangeMeasureTool);
        areaMeasureTool.on("drawstart", self.onMeasureDrawStart);
        areaMeasureTool.on("drawend", self.onMeasureDrawEnd);
        interactions.push(areaMeasureTool);

        ////let drawingTool = new Draw({
        ////    source: self.drawingLayer.getSource(),
        ////    type: 'Polygon',
        ////    style: self.drawingStyle
        ////});
        ////drawingTool.set(self.propertyKeyName, "drawingTool");
        ////interactions.push(drawingTool);

        return interactions;
    }

    private getExtentByCoordinateWithBuffer = (coordinate: Coordinate): extent.Extent => {
        let self = this;
        let pixel = self.map.getPixelFromCoordinate(coordinate);
        let hitToleranceCoordinate = self.map.getCoordinateFromPixel([pixel[0] + self.hitToleranceInPixel, pixel[1] + self.hitToleranceInPixel]);
        let buffer = hitToleranceCoordinate[0] - coordinate[0];
        if (buffer < 0) {
            buffer *= -1;
        }

        let bbox = extent.boundingExtent([coordinate]);
        return extent.buffer(bbox, buffer);
    };

    private addKmlLayer(format: KML, features: Feature<Geometry>[], fileName: string) {
        this.kmlLayer = new VectorLayer({
            source: new VectorSource({ format, features }),
            properties: {
                name: fileName,
                removable: true
            }
        });

        this.map.addLayer(this.kmlLayer);
    };

    private customStyleToKmlPointFeature(label: string) {
        return new Style({
            image: new Circle({
                radius: 4,
                fill: new Fill({
                    color: [0, 0, 0, 0.3],
                }),
                stroke: new Stroke({
                    color: [0, 0, 0, 1],
                    width: 1.25,
                }),
            }),
            zIndex: Infinity,
            text: new Text({ text: label, textAlign: "left", offsetX: 5 })
        });
    };

    private addFeaturesToCart(features: Array<Feature<Geometry>>, fileName: string) {
        let objects = [];
        for (let i = 0; i < features.length; i++) {
            const geometry = features[i].getGeometry();
            const geometryType = geometry.getType();
            const geometryCoordinates = (geometry as any).getCoordinates();
            const coordinates = JSON.stringify(geometryCoordinates);

            const featureProps = features[i].getProperties();
            const propName = featureProps ? featureProps.name : '';
            const objectName = propName ? propName : features.length > 1 ? `${fileName}_${i + 1}` : fileName;
            objects.push({
                Id: kendo.guid(),
                Type: 8888, // KML = 8888
                SubType: 'KML',
                Number: getResource("KML"),
                Title: objectName,
                Description: `${geometryType}|${coordinates}`,
            });
        }

        requestOptional(
            "AddSelectedMap",
            "Map",
            {
                type: "POST",
                data: {
                    objects: objects,
                    addToCart: true,
                    intersectKey: "SelectedCartObjectsKey",
                },
                success: (cartItems: number) => {
                    if (!cartItems && cartItems != 0) {
                        return;
                    }
                    cart.refresh();
                }
            }
        );
    }

    private selectObjects = (extent: extent.Extent, clearOldSelection: boolean, kmlGeomDesc = "") => {
        let self = this;
        let layers = self.getVisibleLayers();
        if (!layers || layers.length < 1) {
            return;
        }

        let scale = self.getScale();
        let urls: string[] = [], parameters: string[] = [];
        for (let i = layers.length - 1; i >= 0; i--) {
            let layer = layers[i];
            let layerSource = layer ? layer.getSource() : null;
            let layerName = layer ? layer.getProperties()["name"] : null;
            let legendItem = layerName ? this.legend.dataSource.data().find((item) => (item as LegendItem).name == layerName) as LegendItem : null;
            if (layerSource) {
                switch (layerSource.constructor) {
                    case TileArcGISRest:
                    case ImageArcGISRest:
                        {
                            let s = layerSource instanceof ImageArcGISRest ? layerSource as ImageArcGISRest : layerSource as TileArcGISRest;
                            let p = { ...s.getParams() };
                            if (legendItem && legendItem.items && legendItem.items.length > 0) {
                                let layerData = (p["layers"] as string).split(':');
                                let layerIds = layerData[1].split(',').map(item => Number(item));
                                let l: number[] = [];
                                for (let j = 0; j < layerIds.length; j++) {
                                    let layerLegendItems = self.findLegendItems(legendItem.items, item => item.id == layerIds[j]);
                                    let layerLegendItem = layerLegendItems && layerLegendItems.length == 1 ? layerLegendItems[0] : null;
                                    if (layerLegendItem && self.isVisibleInScale(layerLegendItem, scale)) {
                                        l.push(layerIds[j]);
                                    }
                                }

                                if (l.length > 0) {
                                    p["layers"] = `${layerData[0]}:${l.join(",")}`;
                                    urls.push(s instanceof ImageArcGISRest ? s.getUrl() : s.getUrls[0]);
                                    parameters.push(JSON.stringify(p));
                                }
                            }

                            break;
                        }
                }
            }
        }

        parameters = self.handleCadLayersParams(urls, parameters, scale);

        if (!urls || urls.length < 1) {
            return;
        }

        let projection = self.map.getView().getProjection();
        requestOptional(
            "SelectObjects",
            "Map",
            {
                type: 'POST',
                data: {
                    urls: urls,
                    parameters: parameters,
                    extent: extent,
                    projection: projection.getCode(),
                    kmlGeomDesc: kmlGeomDesc,
                    clearOldSelection: clearOldSelection
                },
                success: (data: SelectModel[]) => {
                    self.drawingLayer.getSource().clear(true);
                    let selectionLayerSource = self.selectionLayer.getSource();
                    if (clearOldSelection) {
                        selectionLayerSource.clear(true);
                    }

                    let oldFeatures = selectionLayerSource.getFeatures();
                    let features: Feature[] = [];
                    if (self.options.mapMode != MapModeType.GeoKartFond) {
                        for (let i = 0; i < data.length; i++) {
                            let format = self.getFeatureFormat(data[i].Format);
                            let options = self.getReadFeatureGeometryOptions(data[i].SpatialReferenceCode);
                            for (let j = 0; j < data[i].Geometries.length; j++) {
                                let featureId = data[i].Objects[j].Hash;
                                if (oldFeatures && oldFeatures.length > 0) {
                                    let oldFeature = selectionLayerSource.getFeatureById(featureId);
                                    if (oldFeature) {
                                        selectionLayerSource.removeFeature(oldFeature);
                                        continue;
                                    }
                                }

                                let feature = new Feature();
                                feature.setId(featureId);
                                feature.setGeometry(format.readGeometry(data[i].Geometries[j], options));
                                features.push(feature);
                            }
                        }

                        if (features.length > 0) {
                            selectionLayerSource.addFeatures(features);
                        }
                    }

                    self.showSelectionListResult();
                }
            });
    }

    private handleCadLayersParams = (urls: string[], parameters: string[], scale: number) => {
        const isParcelsLegendItemVisible = this.isVisibleInScaleCachedCad(1, scale);
        const isBuildingsLegendItemVisible = this.isVisibleInScaleCachedCad(2, scale);
        const isParcelsLayerVisible = this.checkCachedCadLayerVisibility('TileLayer_Parcels');
        const isBuildingsLayerVisible = this.checkCachedCadLayerVisibility('TileLayer_Buildings');

        const cadLayerInx = urls.findIndex(url => url.indexOf(globalVariables.cadastreUrl) !== -1);
        if (cadLayerInx > -1) {
            const _params = parameters[cadLayerInx];
            const parsedParams = JSON.parse(_params);
            const layers = parsedParams['layers'];
            const splittedLayerParams: string = layers.split(':')[1];
            const layerIds = splittedLayerParams.split(',');
            if (isParcelsLayerVisible && isParcelsLegendItemVisible) {
                layerIds.push('1');
            }
            if (isBuildingsLayerVisible && isBuildingsLegendItemVisible) {
                layerIds.push('2');
            }

            parsedParams['layers'] = `show:${layerIds.join(',')}`;
            parameters[cadLayerInx] = JSON.stringify(parsedParams);
        } else {
            const addedLayerIds = [];
            if (isParcelsLayerVisible && isParcelsLegendItemVisible) {
                addedLayerIds.push('1');
            }
            if (isBuildingsLayerVisible && isBuildingsLegendItemVisible) {
                addedLayerIds.push('2');
            }

            if (addedLayerIds.length) {
                parameters.push(JSON.stringify({ layers: `show:${addedLayerIds.join(',')}` }));
                urls.push(globalVariables.cadastreUrl);
            }
        }

        return parameters;
    }

    private checkCachedCadLayerVisibility = (layerId: string) => {
        const targetLayer = this.map.getAllLayers().find(l => l.getProperties()['id'] === layerId);
        if (targetLayer) {
            return targetLayer.getVisible();
        }
        return false;
    }

    private isVisibleInScaleCachedCad = (layerId: number, scale: number) => {
        let self = this;
        let legendItem = this.legend.dataSource.data().find((item) => (item as LegendItem).name == "cadastre") as LegendItem;
        if (legendItem) {
            let layerLegendItems = self.findLegendItems(legendItem.items, item => item.id == layerId);
            let layerLegendItem = layerLegendItems && layerLegendItems.length == 1 ? layerLegendItems[0] : null;
            if (layerLegendItem && self.isVisibleInScale(layerLegendItem, scale)) {
                return true;
            }
        }
        return false;
    }

    private getTitle = (legentItem: LegendItem): string => {
        return legentItem.title ? legentItem.title : getResource(legentItem.name);
    }

    private getObjectInfoAsync = async (coordinate: Coordinate) => {
        let self = this;
        self.closeOldMapWindows();

        let layers = self.getVisibleLayers();
        if (!layers || layers.length < 1) {
            return;
        }

        let scale = self.getScale();
        let view = self.map.getView();
        let resolution = view.getResolution();
        let projection = view.getProjection();
        let html: string;
        for (let i = layers.length - 1; i >= 0; i--) {
            let layer = layers[i] as Layer;
            let layerSource = layer.getSource();
            switch (layerSource.constructor) {
                case TileWMS:
                case ImageWMS:
                    {
                        let s = layerSource instanceof ImageWMS ? layerSource as ImageWMS : layerSource as TileWMS;
                        let params = s.getParams();
                        let visibleLayersText = s.getParams()["layers"] as string;
                        let visibleLayers = visibleLayersText ? visibleLayersText.split(',').map(item => item) : null;
                        if (!visibleLayers || visibleLayers.length < 1) {
                            continue;
                        }

                        let layerProperties = layer.getProperties();
                        let layers = layerProperties["layers"] as any[];
                        let layerNames = layers?.map(item => {
                            return item["name"] ? item["name"] : item["Name"];
                        });

                        var queryLayers = visibleLayers.sort((a, b) => layerNames?.indexOf(a) - layerNames?.indexOf(b));
                        for (var j = 0; j < queryLayers.length; j++) {
                            let url = s.getFeatureInfoUrl(
                                coordinate,
                                resolution,
                                projection,
                                {
                                    query_layers: queryLayers[j],
                                    cql_filter: params["cql_filter"],
                                    buffer: self.hitToleranceInPixel,
                                    feature_count: 1,
                                    info_format: "application/json",
                                });

                            let data = await requestOptionalUrlAsync(url);
                            if (data) {
                                let features = data["features"] as any[];
                                let feature = features && features.length > 0 ? features[0] : null;
                                if (feature) {
                                    html = kendo.template($("#objectInfoTemplate").html())(feature);
                                    break;
                                }
                            }
                        }

                        break;
                    }

                case ImageArcGISRest:
                case TileArcGISRest:
                    {
                        let layerName = layer ? layer.getProperties()["name"] : null;
                        let legendItem = layerName ? this.legend.dataSource.data().find((item) => (item as LegendItem).name == layerName) as LegendItem : null;
                        let s = layerSource instanceof ImageArcGISRest ? layerSource as ImageArcGISRest : layerSource as TileArcGISRest;
                        let p = { ...s.getParams() };
                        if (legendItem && legendItem.items && legendItem.items.length > 0) {
                            let layerData = (p["layers"] as string).split(':');
                            let layerIds = layerData[1].split(',').map(item => Number(item));

                            // TODO - must be in same order as legend - top visible layers first
                            if (self.checkCachedCadLayerVisibility('TileLayer_Borders')) {
                                layerIds.push(15);
                            }

                            if (self.checkCachedCadLayerVisibility('TileLayer_Buildings')) {
                                layerIds.push(2);
                            }

                            if (self.checkCachedCadLayerVisibility('TileLayer_Parcels')) {
                                layerIds.push(1);
                            }

                            let l: number[] = [];
                            let names: string[] = [];
                            for (let j = 0; j < layerIds.length; j++) {
                                let layerLegendItems = self.findLegendItems(legendItem.items, item => item.id == layerIds[j]);
                                let layerLegendItem = layerLegendItems && layerLegendItems.length == 1 ? layerLegendItems[0] : null;
                                if (layerLegendItem && self.isVisibleInScale(layerLegendItem, scale)) {
                                    l.push(layerIds[j]);
                                    names.push(`${self.getTitle(legendItem)} ${self.getTitle(layerLegendItem)}`);
                                }
                            }

                            if (l.length > 0) {
                                p["layers"] = `${layerData[0]}:${l.join(",")}`;
                                p["names"] = names.join(",");
                                let url = s instanceof ImageArcGISRest ? s.getUrl() : s.getUrls[0];
                                let extent = self.getExtentByCoordinateWithBuffer(coordinate);
                                html = await requestOptionalAsync(
                                    "GetObjectInfo",
                                    "Map",
                                    {
                                        type: "POST",
                                        data: {
                                            url: url,
                                            parameters: JSON.stringify(p),
                                            extent: extent,
                                            projection: projection.getCode()
                                        }
                                    });
                            }
                        }
                        break;
                    }

                case Vector:
                    {
                        let pixel = self.map.getPixelFromCoordinate(coordinate);
                        let features = self.map
                            .getFeaturesAtPixel(
                                pixel,
                                {
                                    layerFilter: (l) => l === layer,
                                    hitTolerance: self.hitToleranceInPixel
                                });
                        let feature = features && features.length > 0 ? features[0] : null;
                        if (feature) {
                            const layerName = layer.getProperties()["name"] as string;
                            if (layerName && (layerName.endsWith(".kml") || layerName.endsWith(".kmz"))) {
                                const geometry = feature.getGeometry();
                                const geometryType = geometry.getType();
                                const geometryCoordinates = (geometry as any).getCoordinates();
                                const coordinates = JSON.stringify(geometryCoordinates);
                                html = kendo.template($("#kmlInfoTemplate").html())({
                                    properties: { ...feature.getProperties(), _kmlGeomDesc: `${geometryType}|${coordinates}` }
                                });
                            } else {
                                html = kendo.template($("#objectInfoTemplate").html())({
                                    properties: feature.getProperties()
                                });
                            }
                        }
                        break;
                    }
            }

            if (html) {
                self.openNewMapWindow(
                    html,
                    {
                        title: getResource("Info"),
                        width: 400,
                        open: (e) => {
                            self.initFloorsDropDown(e.sender.wrapper, layer);
                        }
                    });
                break;
            }
        }
    }

    private isVisibleInScale = (layerLegendItem: LegendItem, scale: number): boolean => {
        return (layerLegendItem.minScale ? scale <= layerLegendItem.minScale : true)
            && (layerLegendItem.maxScale ? scale >= layerLegendItem.maxScale : true);
    };

    private getVisibleLayers = (): Layer[] => {
        let self = this;
        return self.findLayers(layer =>
        ((layer.getProperties()['skipFromLegend'] !== true &&
            layer.getVisible() &&
            layer instanceof Layer) || (layer.getProperties()["name"] === 'cadastre'))).map(item => item as Layer);
    };

    private showSelectionListResult = () => {
        let self = this;
        $(".map-control .js-hover-trigger[href='#map-search']:not(.opened)").trigger("click");
        $(".map-control #map-search .gkf-export [name='exportButton']")?.hide();
        requestOptional(
            "SearchResult",
            "Map",
            {
                type: "GET",
                success: self.successSearch
            }
        )
    }

    private onActiveChangeMeasureTool = (e: ObjectEvent) => {
        let self = this;
        let active = !(e.oldValue as boolean);
        if (active) {
            self.createHelpMeasureTooltip();
            self.createMeasureTooltip();

            // Hook events:
            self.map.on('pointermove', self.onMapPointerMoveMeasure);
            self.map.getViewport().addEventListener('mouseout', self.onMeasureViewMouseOut);
        }
        else {
            self.drawingLayer.getSource().clear(true);
            self.removeOverlay(self.measureTooltip);
            self.measureTooltip = null;
            self.removeOverlay(self.measureHelpTooltip);
            self.measureHelpTooltip = null;
            self.measureFeature = null;

            // Unhook events:
            self.map.un('pointermove', self.onMapPointerMoveMeasure);
            self.map.getViewport().removeEventListener('mouseout', self.onMeasureViewMouseOut);
        }
    }

    private performPointSelection = (mapBrowserEvent: MapBrowserEvent<KeyboardEvent | PointerEvent | WheelEvent>) => {
        let self = this;
        if (mapBrowserEvent.type == MapBrowserEventType.SINGLECLICK) {
            let browserEvent = (
                mapBrowserEvent.originalEvent
            );

            let keyboardEvent = mapBrowserEvent.originalEvent as KeyboardEvent;
            let extent = self.getExtentByCoordinateWithBuffer(mapBrowserEvent.coordinate);
            self.selectObjects(extent, !(keyboardEvent && keyboardEvent.shiftKey));

            browserEvent.preventDefault();
            return false;
        }

        return true;
    }

    private onActiveChangeInfoTool = (e: ObjectEvent) => {
        let self = this;
        let active = !(e.oldValue as boolean);
        if (!active) {
            self.closeOldMapWindows();
        }
    }

    private onActiveChangeSelectionTool = (e: ObjectEvent) => {
        let self = this;
        let active = !(e.oldValue as boolean);
        if (active) {
            self.map.on('singleclick', self.performPointSelection);
        }
        else {
            self.map.un('singleclick', self.performPointSelection);
        }
    }

    private removeOverlay = (overlay: Overlay) => {
        let self = this;
        if (overlay) {
            $(overlay.getElement()).remove();
            self.map.removeOverlay(overlay);
            overlay = null;
        }
    };

    private onMeasureDrawStart = (e: DrawEvent) => {
        let self = this;
        self.drawingLayer.getSource().clear(true);
        self.measureFeature = e.feature;
        self.measureGeometryChangeListener = self.measureFeature.getGeometry().on('change', function (evt) {
            const geom = evt.target;
            let output;
            let tooltipCoord: Coordinate;
            if (geom instanceof Polygon) {
                output = self.formatArea(geom);
                tooltipCoord = geom.getInteriorPoint().getCoordinates();
            } else if (geom instanceof LineString) {
                output = self.formatLength(geom);
                tooltipCoord = geom.getLastCoordinate();
            }

            if (tooltipCoord) {
                self.measureTooltip.getElement().innerHTML = output;
                self.measureTooltip.setPosition(tooltipCoord);
            }
        });
    }

    private onMeasureDrawEnd = () => {
        let self = this;

        self.measureTooltip.getElement().className = 'ol-tooltip ol-tooltip-static';
        self.measureTooltip.setOffset([0, -7]);
        // unset sketch
        self.measureFeature = null;

        unByKey(self.measureGeometryChangeListener);
    }

    private onMapPointerMoveMeasure = (e: MapBrowserEvent<any>) => {
        let self = this;
        if (e.dragging) {
            return;
        }

        let helpMsg = getResource('ClickToStartDrawing');
        if (self.measureFeature) {
            const geom = self.measureFeature.getGeometry();
            if (geom instanceof Polygon) {
                helpMsg = getResource('ClickToContinueDrawingThePolygon');
            } else if (geom instanceof LineString) {
                helpMsg = getResource('ClickToContinueDrawingTheLine');
            }
        }

        let helpTooltipElement = $(self.measureHelpTooltip.getElement());
        helpTooltipElement.html(helpMsg);
        self.measureHelpTooltip.setPosition(e.coordinate);
        helpTooltipElement.removeClass('hidden');
    };

    private onMeasureViewMouseOut = (e: MouseEvent) => {
        let self = this;
        $(self.measureHelpTooltip.getElement()).addClass('hidden');
    };

    private onInteractionActiveChange = (e: ObjectEvent) => {
        let self = this;
        let interaction = e.target as Interaction;
        if (!interaction && e.key !== "active") {
            return;
        }

        let active = !(e.oldValue as boolean);
        let activeClass = "active";
        let target = $(self.map.getTargetElement());
        let toolName = interaction.get(self.propertyKeyName);
        let targetClass = toolName;
        if (active) {
            $(`.tool-js.${activeClass}`).removeClass(activeClass);
            $(`a#${toolName}`).addClass(activeClass);

            target.addClass(targetClass);
            self.map.getInteractions().forEach((i) => {
                let name = i.get(self.propertyKeyName);
                if (!name || !i.getActive() || name === toolName) {
                    return;
                }

                i.setActive(false);
                if (i instanceof DragBox) {
                    let dragBox = i as any;
                    const style = dragBox.box_.element_.style;
                    style.left = 0;
                    style.top = 0;
                    style.width = 0;
                    style.height = 0;
                }
            });
        }
        else {
            target.removeClass(targetClass);
        }

        let callback = interaction.get(self.propertyKeyActivateChange) as Function;
        if (callback) {
            callback.call(callback, e);
        }
    };

    private formatLength = (line: LineString) => {
        let self = this;
        var projection = self.map.getView().getProjection();
        const length = getLength(line.clone().transform(projection, 'EPSG:7801'), { projection: projection });
        let output;
        if (length > 100) {
            output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km';
        } else {
            output = Math.round(length * 100) / 100 + ' ' + 'm';
        }
        return output;
    };

    private formatArea = (polygon: Polygon) => {
        let self = this;
        var projection = self.map.getView().getProjection();
        const area = getArea(polygon.clone().transform(projection, 'EPSG:7801'), { projection: projection });
        let output;
        if (area > 10000) {
            output = Math.round((area / 1000000) * 100) / 100 + ' ' + 'km<sup>2</sup>';
        } else {
            output = Math.round(area * 100) / 100 + ' ' + 'm<sup>2</sup>';
        }
        return output;
    };

    private createHelpMeasureTooltip = () => {
        let self = this;
        if (!self.measureHelpTooltip) {
            let helpTooltipElement = document.createElement('div');
            helpTooltipElement.className = 'ol-tooltip';
            self.measureHelpTooltip = new Overlay({
                element: helpTooltipElement,
                offset: [15, 0],
                positioning: 'center-left',
            });
            self.map.addOverlay(self.measureHelpTooltip);
        }
    }

    private createMeasureTooltip = () => {
        let self = this;
        if (!self.measureTooltip) {
            let measureTooltipElement = document.createElement('div');
            measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure';
            self.measureTooltip = new Overlay({
                element: measureTooltipElement,
                offset: [0, -15],
                positioning: 'bottom-center',
                stopEvent: false,
                insertFirst: false,
            });
            self.map.addOverlay(self.measureTooltip);
        }
    }

    private findInteractionByFilter = (filter: (i: Interaction) => boolean): Interaction => {
        let self = this;
        return self.map.getInteractions().getArray().find(interaction => filter(interaction));
    }

    private getControls = (): Control[] => {
        let self = this;
        return [
            new ScaleLine({ minWidth: 200, maxWidth: 200 }),
            new Attribution({ collapsible: false }),
            new MousePosition({
                projection: self.clientProjection,
                coordinateFormat: (cc: coordinate.Coordinate): string => {
                    return coordinate.format(cc, `${self.clientProjectionName} {y}, {x}`, self.coordinateDecimals);
                }
            })
        ];
    }

    private setMapModeAsync = async (mode: MapModeType) => {
        let self = this;
        self.options.mapMode = mode;
        $("#GeodeticNetworkPicker").closest(".k-dropdownlist").hide();
        $("#TopoMapsPicker").closest(".k-dropdownlist").hide();
        let element = $(`a.mapMode-js[data-mode=${MapModeType[mode]}]`);
        let wraper = element.closest("ul");
        wraper.find("a.mapMode-js.active").removeClass("active");
        element.addClass("active");

        let layerNames = self.layerModes[mode] as string[];
        if (!layerNames) {
            return;
        }

        let layers: BaseLayer[] = [...self.map.getLayers().getArray()];
        while (layers.length > 0) {
            let layer = layers.shift();
            let layerProperties = layer.getProperties();
            if (layerProperties['skipFromLegend'] !== true) {
                let layerName = layerProperties["name"];
                let visible = layerNames.indexOf(layerName) > -1;

                if (layer instanceof GroupLayer) {
                    let groupLayers = (layer as GroupLayer).getLayers().getArray();
                    layers.push(...groupLayers);
                }
                else {
                    if (layer.get('name') == 'cadastre') {
                        self.handleCadLayersVisibility(layer);
                    }
                    layer.setVisible(visible);
                }
            }
        }

        if (self.legend) {
            self.legend.setDataSource(
                new kendo.data.HierarchicalDataSource(
                    {
                        data: await self.getMapLayersDataSourceAsync()
                    }))
        }

        let searchTabStrip = $("#map-search-tabs").data("kendoTabStrip") as kendo.ui.TabStrip;
        if (searchTabStrip) {
            searchTabStrip.unbind("show");
            searchTabStrip.bind("show", (e: kendo.ui.TabStripShowEvent) => {
                let self = this;
                self.checkMapHeight();
            });

            let select = `[data-mode=${MapModeType[mode]}]`;
            searchTabStrip.tabGroup.find(`.k-item.k-tabstrip-item${select}`).show().siblings(`[data-mode!=${MapModeType[mode]}]`).hide();
            searchTabStrip.select(`li${select}:first`);
        }
        if (mode == 2) {
            $(".gkf").show();
        } else {
            $(".gkf").hide();
        }

        if (mode == 3) {
            $(".coast-cad").show();
        } else {
            $(".coast-cad").hide();
        }

        if (mode == MapModeType.GeoKartFond) {
            let geodeticNetworkPicker = $("#GeodeticNetworkPicker");
            geodeticNetworkPicker.closest(".k-dropdownlist").show();

            let topoMapsPicker = $("#TopoMapsPicker");
            topoMapsPicker.closest(".k-dropdownlist").show();

            $("#map-search-tabs").data("kendoTabStrip").select(4);
            $("#GeodeticNetworkPicker").data("kendoDropDownList").select(1);
            $("#TopoMapsPicker").data("kendoDropDownList").select(0);
        }

        //let visibleTiledCadLayers = false;
        //if (mode == MapModeType.Cadastre) {
        //    visibleTiledCadLayers = true;
        //} else {
        //    visibleTiledCadLayers = false;
        //}
        //[2, 15].forEach(cadLayerId => { // , 17
        //    self.setTileLayersVisibility(cadLayerId, visibleTiledCadLayers);
        //})

        self.setTileLayersVisibility(1, mode == MapModeType.Cadastre);
        self.setTileLayersVisibility(2, mode == MapModeType.Cadastre);
        self.setTileLayersVisibility(15, mode == MapModeType.Cadastre);
        //self.setTileLayersVisibility(17, mode == MapModeType.Cadastre);
    };

    private handleCadLayersVisibility = (layer: BaseLayer) => {
        var layerEventsKey = layer.on("change:visible", (e: any) => {
            const l = e.target as ImageLayer<ImageArcGISRest>;
            const s = l.getSource();
            var sourceEventsKey = s.once("change", (e: any) => {
                const layerSource = e.target;
                const layerParams = layerSource.getParams && layerSource.getParams();
                if (layerParams && layerParams['layers']) {
                    let targetLayerParams = layerParams['layers'];
                    if (targetLayerParams) {
                        if (targetLayerParams.indexOf('15') !== -1) {
                            targetLayerParams = targetLayerParams.replace(/15,/, '');
                        }
                        if (targetLayerParams.indexOf(',2,') !== -1) {
                            targetLayerParams = targetLayerParams.replace(/,2,/, ',');
                        }
                        if (targetLayerParams.indexOf(',1,') !== -1) {
                            targetLayerParams = targetLayerParams.replace(/,1,/, ',');
                        }
                        //if (targetLayerParams.indexOf('17') !== -1) {
                        //    targetLayerParams = targetLayerParams.replace(/17,/, '');
                        //}
                    }
                    layerSource.updateParams({ layers: targetLayerParams });

                    s.un("change", sourceEventsKey.listener);

                    layer.un("change:visible", layerEventsKey.listener);
                }
            })
        })
    }

    private setBaseMap = (layerName: string) => {
        let self = this;

        let groupLayer = self.getLayerByName("base") as GroupLayer;
        if (!groupLayer) {
            return;
        }

        let layers = groupLayer.getLayers().getArray();
        for (let i = 0; i < layers.length; i++) {
            let layer = layers[i];
            if (layerName) {
                layer.setVisible(layer.getProperties()["name"] == layerName);
            }
            else if (layer.getVisible()) {
                layer.setVisible(false);
            }
        }

        let baseMapClass = "baseMap-js";
        let element = $(`a.${baseMapClass}[data-layer=${(layerName ? layerName : '')}]`);
        let wraper = element.closest("ul");
        wraper.find(`a.${baseMapClass}.active`).removeClass("active");
        element.addClass("active");
    };

    public checkMapHeight = () => {
        setTimeout(function () {
            if ($('.map .opened.map-dropdown').length) {
                let nominal = window.innerHeight - $('.map .opened.map-dropdown').offset().top - 50
                $('.map .opened.map-dropdown').css({ maxHeight: nominal + "px" });
            }
        }, 100)
    }

    public successSearch = (data) => {
        let self = this;
        if (data["success"] === false) {
            let tabStrip = $("#map-search-tabs").data("kendoTabStrip");
            let contentElementSelector = tabStrip.contentElement(tabStrip.select().index());
            $(contentElementSelector).html(data.result);
        } else {
            $("#search-result").html(data);
            $('.mc-results').slideDown(200);
            self.checkMapHeight();
        }
    }

    public drawDwgResult = (dwgData, fileName) => {
        const parsedDwgData = JSON.parse(dwgData);
        const layers = parsedDwgData.layers;
        let extent = [];

        let dwgLayersData = {};
        for (let layerKey in layers) {
            if (layerKey.toLowerCase() !== 'polygon') {
                const isZoomEnabled = layerKey === Object.keys(layers)[Object.keys(layers).length - 1]
                const [currentDwgLayers, _extent] = this.drawDwgLayer(layers[layerKey], isZoomEnabled);
                if (_extent) {
                    extent = _extent;
                }
                for (var i in currentDwgLayers) {
                    if (dwgLayersData[i]) {
                        dwgLayersData[i] = dwgLayersData[i].concat(currentDwgLayers[i])
                    } else {
                        dwgLayersData[i] = currentDwgLayers[i];
                    }
                }
            }
        }

        let _dwgLayers = [];
        for (var i in dwgLayersData) {
            const esriJson = dwgLayersData[i];
            let dwgLayerSource = new VectorSource({ features: esriJson });
            const attr = esriJson[0].getProperties();
            let _dwgMapLayer = new VectorLayer({
                source: dwgLayerSource,
                properties: {
                    name: i, // `${dwgFileName} - ${jsonType}`
                    removable: true
                },
                visible: attr['LyrOn'] && !attr['LyrFrzn'] ? true : false // !attr['LyrLock']
            });
            _dwgLayers.push(_dwgMapLayer);
        }

        const groupLayer = new GroupLayer({
            properties: {
                name: fileName,
                removable: true
            },
            layers: _dwgLayers
        });

        groupLayer.setExtent(extent);

        this.dwgLayers.push(groupLayer);
        this.map.addLayer(groupLayer);
    }

    public drawShpResult = (shpData, fileName) => {
        const parsedDwgData = JSON.parse(shpData);
        const layers = parsedDwgData.layers;

        for (var i = 0; i < layers.length; i++) {
            var esriJsonFormat = new EsriJSON();
            var esriJson = esriJsonFormat.readFeatures(layers[i]);
            let shpLayerSource = new VectorSource({ features: esriJson });
            let _shpMapLayer = new VectorLayer({
                source: shpLayerSource,
                properties: {
                    name: fileName
                }
            });
            this.shpLayer = _shpMapLayer;
            this.map.addLayer(_shpMapLayer);
            this.zoomToExtent(shpLayerSource.getExtent());
        }
    }

    public initTobelQuickSearch(tobelApiUrl: string) {
        let self = this;
        rebindEvent("click", "#quickSearch", function (e) {
            self.performTobelQuickSearch(tobelApiUrl);
        });
    }

    private performTobelQuickSearch(tobelApiUrl: string) {
        let self = this;
        let inputValue = $('#search-input').val();
        if (inputValue === '') {
            displayMessage(getResource("QuickSearchEmpty"), messageType.error);
            return;
        }

        requestOptionalUrl(
            tobelApiUrl + 'api/search/QuickSearch?search=' + inputValue,
            {
                type: "GET",
                success: (data: TobelSearchResults) => {
                    if (data.success) {
                        self.showTobelSearchResults(data);
                    } else {
                        displayMessage(data.message, messageType.error)
                    }
                }
            });
    }

    private showTobelSearchResults(data: TobelSearchResults) {
        let self = this;
        if (!data.success) {
            displayMessage(data.message || "Search failed", messageType.error);
            return;
        }

        const mapProj = self.map.getView().getProjection().getCode();

        if (data.featureCount === 0) {
            // No features — zoom to extent if provided
            const layerExtent = data.extent as number[] | undefined;
            if (layerExtent) {
                let viewProjection = self.map.getView().getProjection().getCode();
                let projection = 'EPSG:4326';

                // Reproject if necessary
                let finalExtent = layerExtent;
                if (projection && projection !== viewProjection) {
                    finalExtent = transformExtent(layerExtent, projection, viewProjection);
                }

                self.zoomToExtent(finalExtent);
            }
        }
        else if (data.featureCount === 1) {
            // Single feature — zoom to its geometry
            const collection = data.featureCollections[0];
            const format = new GeoJSON();
            const olFeatures = format.readFeature(collection.features[0], {
                dataProjection: collection.epsg,
                featureProjection: mapProj
            });

            let olExtent = extent.createEmpty();
            const features = Array.isArray(olFeatures) ? olFeatures : [olFeatures];
            features.forEach((feature) => {
                const geom = feature.getGeometry();
                if (geom) {
                    extent.extend(olExtent, geom.getExtent());
                }
            });
            self.zoomToExtent(olExtent, collection.epsg);
        }
        else {
            // Multiple collections — combine all extents
            const allExtents: number[][] = [];

            data.featureCollections.forEach(collection => {
                const format = new GeoJSON();

                collection.features.forEach(feature => {
                    const olFeatures = format.readFeature(feature, {
                        dataProjection: collection.epsg,
                        featureProjection: mapProj
                    });
                    const features = Array.isArray(olFeatures) ? olFeatures : [olFeatures];
                    features.forEach((feature) => {
                        const geom = feature.getGeometry();
                        if (geom) {
                            self.selectionLayer.getSource().addFeature(feature);
                        }
                    });
                });

                const layerExtent = collection.extent as number[] | undefined;
                if (layerExtent && layerExtent.length === 4) {
                    let viewProjection = self.map.getView().getProjection().getCode();
                    let finalExtent = layerExtent;

                    if (collection.epsg && collection.epsg !== viewProjection) {
                        finalExtent = transformExtent(layerExtent, collection.epsg, viewProjection);
                    }

                    allExtents.push(finalExtent);
                }
            });

            if (allExtents.length > 0) {
                // Merge all extents
                const combinedExtent = allExtents.reduce((acc, e) => [
                    Math.min(acc[0], e[0]),
                    Math.min(acc[1], e[1]),
                    Math.max(acc[2], e[2]),
                    Math.max(acc[3], e[3])
                ]);

                self.zoomToExtent(combinedExtent);
            }
        }
    }

    private drawDwgLayer = (dwgLayer, isZoomEnabled): [{}, number[]] => {
        const autodeskColorMap = [{ "cadNumber": -2, "rgbColor": [0, 0, 0] }, { "cadNumber": 1, "rgbColor": [255, 0, 0] }, { "cadNumber": 2, "rgbColor": [255, 255, 0] }, { "cadNumber": 3, "rgbColor": [0, 255, 0] }, { "cadNumber": 4, "rgbColor": [0, 255, 255] }, { "cadNumber": 5, "rgbColor": [0, 0, 255] }, { "cadNumber": 6, "rgbColor": [255, 0, 255] }, { "cadNumber": 7, "rgbColor": [0, 0, 0] }, { "cadNumber": 8, "rgbColor": [65, 65, 65] }, { "cadNumber": 9, "rgbColor": [128, 128, 128] }, { "cadNumber": 10, "rgbColor": [255, 0, 0] }, { "cadNumber": 11, "rgbColor": [255, 170, 170] }, { "cadNumber": 12, "rgbColor": [189, 0, 0] }, { "cadNumber": 13, "rgbColor": [189, 126, 126] }, { "cadNumber": 14, "rgbColor": [129, 0, 0] }, { "cadNumber": 15, "rgbColor": [129, 86, 86] }, { "cadNumber": 16, "rgbColor": [104, 0, 0] }, { "cadNumber": 17, "rgbColor": [104, 69, 69] }, { "cadNumber": 18, "rgbColor": [79, 0, 0] }, { "cadNumber": 19, "rgbColor": [79, 53, 53] }, { "cadNumber": 20, "rgbColor": [255, 63, 0] }, { "cadNumber": 21, "rgbColor": [255, 191, 170] }, { "cadNumber": 22, "rgbColor": [189, 46, 0] }, { "cadNumber": 23, "rgbColor": [189, 141, 126] }, { "cadNumber": 24, "rgbColor": [129, 31, 0] }, { "cadNumber": 25, "rgbColor": [129, 96, 86] }, { "cadNumber": 26, "rgbColor": [104, 25, 0] }, { "cadNumber": 27, "rgbColor": [104, 78, 69] }, { "cadNumber": 28, "rgbColor": [79, 19, 0] }, { "cadNumber": 29, "rgbColor": [79, 59, 53] }, { "cadNumber": 30, "rgbColor": [255, 127, 0] }, { "cadNumber": 31, "rgbColor": [255, 212, 170] }, { "cadNumber": 32, "rgbColor": [189, 94, 0] }, { "cadNumber": 33, "rgbColor": [189, 157, 126] }, { "cadNumber": 34, "rgbColor": [129, 64, 0] }, { "cadNumber": 35, "rgbColor": [129, 107, 86] }, { "cadNumber": 36, "rgbColor": [104, 52, 0] }, { "cadNumber": 37, "rgbColor": [104, 86, 69] }, { "cadNumber": 38, "rgbColor": [79, 39, 0] }, { "cadNumber": 39, "rgbColor": [79, 66, 53] }, { "cadNumber": 40, "rgbColor": [255, 191, 0] }, { "cadNumber": 41, "rgbColor": [255, 234, 170] }, { "cadNumber": 42, "rgbColor": [189, 141, 0] }, { "cadNumber": 43, "rgbColor": [189, 173, 126] }, { "cadNumber": 44, "rgbColor": [129, 96, 0] }, { "cadNumber": 45, "rgbColor": [129, 118, 86] }, { "cadNumber": 46, "rgbColor": [104, 78, 0] }, { "cadNumber": 47, "rgbColor": [104, 95, 69] }, { "cadNumber": 48, "rgbColor": [79, 59, 0] }, { "cadNumber": 49, "rgbColor": [79, 73, 53] }, { "cadNumber": 50, "rgbColor": [255, 255, 0] }, { "cadNumber": 51, "rgbColor": [255, 255, 170] }, { "cadNumber": 52, "rgbColor": [189, 189, 0] }, { "cadNumber": 53, "rgbColor": [189, 189, 126] }, { "cadNumber": 54, "rgbColor": [129, 129, 0] }, { "cadNumber": 55, "rgbColor": [129, 129, 86] }, { "cadNumber": 56, "rgbColor": [104, 104, 0] }, { "cadNumber": 57, "rgbColor": [104, 104, 69] }, { "cadNumber": 58, "rgbColor": [79, 79, 0] }, { "cadNumber": 59, "rgbColor": [79, 79, 53] }, { "cadNumber": 60, "rgbColor": [191, 255, 0] }, { "cadNumber": 61, "rgbColor": [234, 255, 170] }, { "cadNumber": 62, "rgbColor": [141, 189, 0] }, { "cadNumber": 63, "rgbColor": [173, 189, 126] }, { "cadNumber": 64, "rgbColor": [96, 129, 0] }, { "cadNumber": 65, "rgbColor": [118, 129, 86] }, { "cadNumber": 66, "rgbColor": [78, 104, 0] }, { "cadNumber": 67, "rgbColor": [95, 104, 69] }, { "cadNumber": 68, "rgbColor": [59, 79, 0] }, { "cadNumber": 69, "rgbColor": [73, 79, 53] }, { "cadNumber": 70, "rgbColor": [127, 255, 0] }, { "cadNumber": 71, "rgbColor": [212, 255, 170] }, { "cadNumber": 72, "rgbColor": [94, 189, 0] }, { "cadNumber": 73, "rgbColor": [157, 189, 126] }, { "cadNumber": 74, "rgbColor": [64, 129, 0] }, { "cadNumber": 75, "rgbColor": [107, 129, 86] }, { "cadNumber": 76, "rgbColor": [52, 104, 0] }, { "cadNumber": 77, "rgbColor": [86, 104, 69] }, { "cadNumber": 78, "rgbColor": [39, 79, 0] }, { "cadNumber": 79, "rgbColor": [66, 79, 53] }, { "cadNumber": 80, "rgbColor": [63, 255, 0] }, { "cadNumber": 81, "rgbColor": [191, 255, 170] }, { "cadNumber": 82, "rgbColor": [46, 189, 0] }, { "cadNumber": 83, "rgbColor": [141, 189, 126] }, { "cadNumber": 84, "rgbColor": [31, 129, 0] }, { "cadNumber": 85, "rgbColor": [96, 129, 86] }, { "cadNumber": 86, "rgbColor": [25, 104, 0] }, { "cadNumber": 87, "rgbColor": [78, 104, 69] }, { "cadNumber": 88, "rgbColor": [19, 79, 0] }, { "cadNumber": 89, "rgbColor": [59, 79, 53] }, { "cadNumber": 90, "rgbColor": [0, 255, 0] }, { "cadNumber": 91, "rgbColor": [170, 255, 170] }, { "cadNumber": 92, "rgbColor": [0, 189, 0] }, { "cadNumber": 93, "rgbColor": [126, 189, 126] }, { "cadNumber": 94, "rgbColor": [0, 129, 0] }, { "cadNumber": 95, "rgbColor": [86, 129, 86] }, { "cadNumber": 96, "rgbColor": [0, 104, 0] }, { "cadNumber": 97, "rgbColor": [69, 104, 69] }, { "cadNumber": 98, "rgbColor": [0, 79, 0] }, { "cadNumber": 99, "rgbColor": [53, 79, 53] }, { "cadNumber": 100, "rgbColor": [0, 255, 63] }, { "cadNumber": 101, "rgbColor": [170, 255, 191] }, { "cadNumber": 102, "rgbColor": [0, 189, 46] }, { "cadNumber": 103, "rgbColor": [126, 189, 141] }, { "cadNumber": 104, "rgbColor": [0, 129, 31] }, { "cadNumber": 105, "rgbColor": [86, 129, 96] }, { "cadNumber": 106, "rgbColor": [0, 104, 25] }, { "cadNumber": 107, "rgbColor": [69, 104, 78] }, { "cadNumber": 108, "rgbColor": [0, 79, 19] }, { "cadNumber": 109, "rgbColor": [53, 79, 59] }, { "cadNumber": 110, "rgbColor": [0, 255, 127] }, { "cadNumber": 111, "rgbColor": [170, 255, 212] }, { "cadNumber": 112, "rgbColor": [0, 189, 94] }, { "cadNumber": 113, "rgbColor": [126, 189, 157] }, { "cadNumber": 114, "rgbColor": [0, 129, 64] }, { "cadNumber": 115, "rgbColor": [86, 129, 107] }, { "cadNumber": 116, "rgbColor": [0, 104, 52] }, { "cadNumber": 117, "rgbColor": [69, 104, 86] }, { "cadNumber": 118, "rgbColor": [0, 79, 39] }, { "cadNumber": 119, "rgbColor": [53, 79, 66] }, { "cadNumber": 120, "rgbColor": [0, 255, 191] }, { "cadNumber": 121, "rgbColor": [170, 255, 234] }, { "cadNumber": 122, "rgbColor": [0, 189, 141] }, { "cadNumber": 123, "rgbColor": [126, 189, 173] }, { "cadNumber": 124, "rgbColor": [0, 129, 96] }, { "cadNumber": 125, "rgbColor": [86, 129, 118] }, { "cadNumber": 126, "rgbColor": [0, 104, 78] }, { "cadNumber": 127, "rgbColor": [69, 104, 95] }, { "cadNumber": 128, "rgbColor": [0, 79, 59] }, { "cadNumber": 129, "rgbColor": [53, 79, 73] }, { "cadNumber": 130, "rgbColor": [0, 255, 255] }, { "cadNumber": 131, "rgbColor": [170, 255, 255] }, { "cadNumber": 132, "rgbColor": [0, 189, 189] }, { "cadNumber": 133, "rgbColor": [126, 189, 189] }, { "cadNumber": 134, "rgbColor": [0, 129, 129] }, { "cadNumber": 135, "rgbColor": [86, 129, 129] }, { "cadNumber": 136, "rgbColor": [0, 104, 104] }, { "cadNumber": 137, "rgbColor": [69, 104, 104] }, { "cadNumber": 138, "rgbColor": [0, 79, 79] }, { "cadNumber": 139, "rgbColor": [53, 79, 79] }, { "cadNumber": 140, "rgbColor": [0, 191, 255] }, { "cadNumber": 141, "rgbColor": [170, 234, 255] }, { "cadNumber": 142, "rgbColor": [0, 141, 189] }, { "cadNumber": 143, "rgbColor": [126, 173, 189] }, { "cadNumber": 144, "rgbColor": [0, 96, 129] }, { "cadNumber": 145, "rgbColor": [86, 118, 129] }, { "cadNumber": 146, "rgbColor": [0, 78, 104] }, { "cadNumber": 147, "rgbColor": [69, 95, 104] }, { "cadNumber": 148, "rgbColor": [0, 59, 79] }, { "cadNumber": 149, "rgbColor": [53, 73, 79] }, { "cadNumber": 150, "rgbColor": [0, 127, 255] }, { "cadNumber": 151, "rgbColor": [170, 212, 255] }, { "cadNumber": 152, "rgbColor": [0, 94, 189] }, { "cadNumber": 153, "rgbColor": [126, 157, 189] }, { "cadNumber": 154, "rgbColor": [0, 64, 129] }, { "cadNumber": 155, "rgbColor": [86, 107, 129] }, { "cadNumber": 156, "rgbColor": [0, 52, 104] }, { "cadNumber": 157, "rgbColor": [69, 86, 104] }, { "cadNumber": 158, "rgbColor": [0, 39, 79] }, { "cadNumber": 159, "rgbColor": [53, 66, 79] }, { "cadNumber": 160, "rgbColor": [0, 63, 255] }, { "cadNumber": 161, "rgbColor": [170, 191, 255] }, { "cadNumber": 162, "rgbColor": [0, 46, 189] }, { "cadNumber": 163, "rgbColor": [126, 141, 189] }, { "cadNumber": 164, "rgbColor": [0, 31, 129] }, { "cadNumber": 165, "rgbColor": [86, 96, 129] }, { "cadNumber": 166, "rgbColor": [0, 25, 104] }, { "cadNumber": 167, "rgbColor": [69, 78, 104] }, { "cadNumber": 168, "rgbColor": [0, 19, 79] }, { "cadNumber": 169, "rgbColor": [53, 59, 79] }, { "cadNumber": 170, "rgbColor": [0, 0, 255] }, { "cadNumber": 171, "rgbColor": [170, 170, 255] }, { "cadNumber": 172, "rgbColor": [0, 0, 189] }, { "cadNumber": 173, "rgbColor": [126, 126, 189] }, { "cadNumber": 174, "rgbColor": [0, 0, 129] }, { "cadNumber": 175, "rgbColor": [86, 86, 129] }, { "cadNumber": 176, "rgbColor": [0, 0, 104] }, { "cadNumber": 177, "rgbColor": [69, 69, 104] }, { "cadNumber": 178, "rgbColor": [0, 0, 79] }, { "cadNumber": 179, "rgbColor": [53, 53, 79] }, { "cadNumber": 180, "rgbColor": [63, 0, 255] }, { "cadNumber": 181, "rgbColor": [191, 170, 255] }, { "cadNumber": 182, "rgbColor": [46, 0, 189] }, { "cadNumber": 183, "rgbColor": [141, 126, 189] }, { "cadNumber": 184, "rgbColor": [31, 0, 129] }, { "cadNumber": 185, "rgbColor": [96, 86, 129] }, { "cadNumber": 186, "rgbColor": [25, 0, 104] }, { "cadNumber": 187, "rgbColor": [78, 69, 104] }, { "cadNumber": 188, "rgbColor": [19, 0, 79] }, { "cadNumber": 189, "rgbColor": [59, 53, 79] }, { "cadNumber": 190, "rgbColor": [127, 0, 255] }, { "cadNumber": 191, "rgbColor": [212, 170, 255] }, { "cadNumber": 192, "rgbColor": [94, 0, 189] }, { "cadNumber": 193, "rgbColor": [157, 126, 189] }, { "cadNumber": 194, "rgbColor": [64, 0, 129] }, { "cadNumber": 195, "rgbColor": [107, 86, 129] }, { "cadNumber": 196, "rgbColor": [52, 0, 104] }, { "cadNumber": 197, "rgbColor": [86, 69, 104] }, { "cadNumber": 198, "rgbColor": [39, 0, 79] }, { "cadNumber": 199, "rgbColor": [66, 53, 79] }, { "cadNumber": 200, "rgbColor": [191, 0, 255] }, { "cadNumber": 201, "rgbColor": [234, 170, 255] }, { "cadNumber": 202, "rgbColor": [141, 0, 189] }, { "cadNumber": 203, "rgbColor": [173, 126, 189] }, { "cadNumber": 204, "rgbColor": [96, 0, 129] }, { "cadNumber": 205, "rgbColor": [118, 86, 129] }, { "cadNumber": 206, "rgbColor": [78, 0, 104] }, { "cadNumber": 207, "rgbColor": [95, 69, 104] }, { "cadNumber": 208, "rgbColor": [59, 0, 79] }, { "cadNumber": 209, "rgbColor": [73, 53, 79] }, { "cadNumber": 210, "rgbColor": [255, 0, 255] }, { "cadNumber": 211, "rgbColor": [255, 170, 255] }, { "cadNumber": 212, "rgbColor": [189, 0, 189] }, { "cadNumber": 213, "rgbColor": [189, 126, 189] }, { "cadNumber": 214, "rgbColor": [129, 0, 129] }, { "cadNumber": 215, "rgbColor": [129, 86, 129] }, { "cadNumber": 216, "rgbColor": [104, 0, 104] }, { "cadNumber": 217, "rgbColor": [104, 69, 104] }, { "cadNumber": 218, "rgbColor": [79, 0, 79] }, { "cadNumber": 219, "rgbColor": [79, 53, 79] }, { "cadNumber": 220, "rgbColor": [255, 0, 191] }, { "cadNumber": 221, "rgbColor": [255, 170, 234] }, { "cadNumber": 222, "rgbColor": [189, 0, 141] }, { "cadNumber": 223, "rgbColor": [189, 126, 173] }, { "cadNumber": 224, "rgbColor": [129, 0, 96] }, { "cadNumber": 225, "rgbColor": [129, 86, 118] }, { "cadNumber": 226, "rgbColor": [104, 0, 78] }, { "cadNumber": 227, "rgbColor": [104, 69, 95] }, { "cadNumber": 228, "rgbColor": [79, 0, 59] }, { "cadNumber": 229, "rgbColor": [79, 53, 73] }, { "cadNumber": 230, "rgbColor": [255, 0, 127] }, { "cadNumber": 231, "rgbColor": [255, 170, 212] }, { "cadNumber": 232, "rgbColor": [189, 0, 94] }, { "cadNumber": 233, "rgbColor": [189, 126, 157] }, { "cadNumber": 234, "rgbColor": [129, 0, 64] }, { "cadNumber": 235, "rgbColor": [129, 86, 107] }, { "cadNumber": 236, "rgbColor": [104, 0, 52] }, { "cadNumber": 237, "rgbColor": [104, 69, 86] }, { "cadNumber": 238, "rgbColor": [79, 0, 39] }, { "cadNumber": 239, "rgbColor": [79, 53, 66] }, { "cadNumber": 240, "rgbColor": [255, 0, 63] }, { "cadNumber": 241, "rgbColor": [255, 170, 191] }, { "cadNumber": 242, "rgbColor": [189, 0, 46] }, { "cadNumber": 243, "rgbColor": [189, 126, 141] }, { "cadNumber": 244, "rgbColor": [129, 0, 31] }, { "cadNumber": 245, "rgbColor": [129, 86, 96] }, { "cadNumber": 246, "rgbColor": [104, 0, 25] }, { "cadNumber": 247, "rgbColor": [104, 69, 78] }, { "cadNumber": 248, "rgbColor": [79, 0, 19] }, { "cadNumber": 249, "rgbColor": [79, 53, 59] }, { "cadNumber": 250, "rgbColor": [51, 51, 51] }, { "cadNumber": 251, "rgbColor": [80, 80, 80] }, { "cadNumber": 252, "rgbColor": [105, 105, 105] }, { "cadNumber": 253, "rgbColor": [130, 130, 130] }, { "cadNumber": 254, "rgbColor": [190, 190, 190] }, { "cadNumber": 255, "rgbColor": [255, 255, 255] }];
        //var geoJsonFormat = new GeoJSON();
        var esriJsonFormat = new EsriJSON();
        // Convert Esri JSON to GeoJSON
        //var geoJsonFeature = geoJsonFormat.readFeature(dwgLayer);
        let featureStyle: Style;
        var esriJson = esriJsonFormat.readFeatures(dwgLayer);
        var layers = {};
        esriJson.forEach(esriFeature => {
            const attr = esriFeature.getProperties();
            const text = attr['Text'];
            const dwgColor = attr['Color'];
            const targetDwgColor = autodeskColorMap.find(c => c.cadNumber === dwgColor);
            let rgbColor = null;
            if (targetDwgColor) {
                rgbColor = targetDwgColor.rgbColor;
            } else {
                rgbColor = [0, 0, 0];
            }
            featureStyle = this.getStyleObject(dwgLayer.geometryType, rgbColor, esriFeature, text);
            if (text && featureStyle.getText()) {
                featureStyle.getText().setText(text);
            }
            esriFeature.setStyle(featureStyle);
            if (layers[attr['Layer']]) {
                layers[attr['Layer']].push(esriFeature);
            } else {
                layers[attr['Layer']] = [esriFeature]
            }
        });

        let extent = [];

        if (isZoomEnabled) {
            let xs = [];
            let ys = [];
            esriJson.forEach(f => {
                const extent = f.getGeometry().getExtent();
                xs.push([extent[0], extent[2]])
                ys.push([extent[1], extent[3]])
            })
            xs = xs.flat().sort((a, b) => a - b)
            ys = ys.flat().sort((a, b) => a - b)
            const X_MIN = 229960;
            const Y_MIN = 4538636;
            const X_MAX = 802902;
            const Y_MAX = 4927723;
            const xMin = xs.find(x => X_MIN < x && X_MAX > x);
            const yMin = ys.find(y => Y_MIN < y && Y_MAX > y);
            const xMax = xs.reverse().find(x => X_MIN < x && X_MAX > x); // xs[xs.length - 1];
            const yMax = ys.reverse().find(y => Y_MIN < y && Y_MAX > y); // ys[ys.length - 1];

            if (xMin && yMin && xMax && yMax) {
                extent = [xMin, yMin, xMax, yMax]
                this.zoomToExtent(extent);
            } else {
                const extFeature = esriJson.find(f => f.getGeometry().getExtent());
                extent = extFeature.getGeometry().getExtent();
                this.zoomToExtent(extent);
            }
        }

        return [layers, extent];
    }

    private getStyleObject(geometryType: string, color: number[], esriFeature: Feature<Geometry>, text: string): Style {
        if (geometryType === "esriGeometryPoint") {
            const pointStyle = {
                image: new Circle({
                    radius: 1,
                    fill: new Fill({
                        color: text ? [0, 0, 0, 0] : color,
                    }),
                    stroke: new Stroke({
                        color: text ? [0, 0, 0, 0] : color,
                        width: 2 / 2,
                    }),
                }),
                zIndex: Infinity,
            };
            if (text) {
                return new Style({
                    ...pointStyle,
                    text: new Text({
                        font: '12px Calibri,sans-serif',
                        overflow: true,
                        fill: new Fill({
                            color: '#000'
                        }),
                        stroke: new Stroke({
                            color: '#fff',
                            width: 1
                        }),
                        textAlign: esriFeature.get('TxtJust') ? esriFeature.get('TxtJust').toLowerCase() : 'left',
                        textBaseline: !esriFeature.get('VertAlign') || esriFeature.get('VertAlign') === 'Baseline' ? '' : esriFeature.get('VertAlign').toLowerCase(),
                    })
                })
            } else {
                return new Style(pointStyle);
            }
        }
        else if (geometryType === "esriGeometryPolyline") {
            return new Style({
                stroke: new Stroke({
                    color: color, // '#ffcc33',
                    width: 2,
                }),
            })
        }
        else if (geometryType === "esriGeometryPolygon") {
            return new Style({
                stroke: new Stroke({
                    width: 5,
                    color: color //"#ff0000"
                }),
                fill: new Fill({
                    color: [0, 0, 0, 0] // color //"#aa2727"
                })
            });
        }
    }

    private getApartmentLayerFilter = (cadNumber: string = null, floor: string = null, defaultFilter: string = "cadregion=-1"): string => {
        let filterParts: string[] = [];
        if (cadNumber) {
            let parts = cadNumber.split('.');
            if (parts.length >= 4) {
                filterParts.push(`ekatte='${parts[0]}'`);
                filterParts.push(`cadregion=${parts[1]}`);
                filterParts.push(`cadimmovable=${parts[2]}`);
                filterParts.push(`cadbuilding=${parts[3]}`);
            }
            if (parts.length >= 5 && !floor) {
                filterParts.push(`cadapp=${parts[4]}`);
            }
        }

        if (filterParts.length > 0 && floor) {
            filterParts.push(`floornumber='${floor}'`);
        }

        return filterParts.length > 0 ? filterParts.join(" and ") : defaultFilter; // Hide layer
    }

    private getRandomId = () => kendo.guid();

    private updateApartmentLayerFilterByObject = (cadNumber: string, type: number, floor: string = null) => {
        let self = this;
        let layerNameIndex = type < 5 ? 0 : 1;
        for (let i = 0; i < self.appartmentLayerData.length; i++) {
            let layer = self.getLayerByName(self.appartmentLayerData[i].name) as Layer;
            if (!layer) {
                return;
            }

            let source = layer.getSource();
            let flag = layerNameIndex == i;
            let filter = flag ? self.getApartmentLayerFilter(cadNumber, floor) : self.getApartmentLayerFilter();
            switch (source.constructor) {
                case ImageWMS: {
                    (source as ImageWMS).updateParams({ 'cql_filter': filter });
                    break;
                }

                case TileWMS: {
                    (source as TileWMS).updateParams({ 'cql_filter': filter });
                    break;
                }

                case ImageArcGISRest:
                case TileArcGISRest: {
                    let arcGisRestSource: ImageArcGISRest | TileArcGISRest;
                    switch (source.constructor) {
                        case ImageArcGISRest: {
                            arcGisRestSource = source as ImageArcGISRest;
                            break;
                        }

                        case TileArcGISRest: {
                            arcGisRestSource = source as TileArcGISRest;
                            break;
                        }
                    }

                    let layerDefs = arcGisRestSource.getParams()["layerDefs"] ? JSON.parse(arcGisRestSource.getParams()["layerDefs"]) : null;
                    if (!layerDefs) {
                        layerDefs = {};
                    }

                    let layerId = self.appartmentLayerData[i].layerId.toString();
                    if (filter) {
                        layerDefs[layerId] = filter;
                    }
                    else if (layerDefs.hasOwnProperty(layerId)) {
                        delete layerDefs[layerId];
                    }

                    arcGisRestSource.updateParams({ layerDefs: JSON.stringify(layerDefs) });
                    break;
                }
            }

            if (flag) {
                let legendItem = self.legendSearch(item => item.layerNameOnMap == self.appartmentLayerData[i].name && item.id == self.appartmentLayerData[i].layerId);
                let node = legendItem ? $(`li[data-uid="${legendItem.uid}"]`) : null;
                if (legendItem && node && node.attr("aria-checked") == "false") {
                    legendItem.set("checked", true);
                    self.legend.trigger("check", { sender: self.legend, node: node });
                }
            }
        }
    }

    private updateRestrictionLayerFilterByObject = (cadNumber: string, type: number, floor: string = null) => {
        let self = this;
        let layerNameIndex = type < 5 ? 0 : 1;
        for (let i = 0; i < self.restrictionLayerData.length; i++) {
            let layer = self.getLayerByName(self.restrictionLayerData[i].name) as Layer;
            if (!layer) {
                return;
            }

            let source = layer.getSource();
            let flag = layerNameIndex == i;
            let filter = flag ? self.getApartmentLayerFilter(cadNumber, floor, self.restrictionDefaultFilter) : self.getApartmentLayerFilter(null, null, self.restrictionDefaultFilter);
            switch (source.constructor) {
                case ImageWMS: {
                    (source as ImageWMS).updateParams({ 'cql_filter': filter });
                    break;
                }

                case TileWMS: {
                    (source as TileWMS).updateParams({ 'cql_filter': filter });
                    break;
                }

                case ImageArcGISRest:
                case TileArcGISRest: {
                    let arcGisRestSource: ImageArcGISRest | TileArcGISRest;
                    switch (source.constructor) {
                        case ImageArcGISRest: {
                            arcGisRestSource = source as ImageArcGISRest;
                            break;
                        }

                        case TileArcGISRest: {
                            arcGisRestSource = source as TileArcGISRest;
                            break;
                        }
                    }

                    let layerDefs = arcGisRestSource.getParams()["layerDefs"] ? JSON.parse(arcGisRestSource.getParams()["layerDefs"]) : null;
                    if (!layerDefs) {
                        layerDefs = {};
                    }

                    let layerId = self.restrictionLayerData[i].layerId.toString();
                    if (filter) {
                        layerDefs[layerId] = filter;
                    }
                    else if (layerDefs.hasOwnProperty(layerId)) {
                        delete layerDefs[layerId];
                    }

                    arcGisRestSource.updateParams({ layerDefs: JSON.stringify(layerDefs) });
                    break;
                }
            }
        }
    }

    private updateProjectObjectFilter = (projectId: string) => {
        let self = this;
        let layerName = self.projectLayersData[0].name;
        let layerIds = self.projectLayersData.map(item => item.layerId);
        let layer = self.getLayerByName(layerName) as Layer;
        if (!layer) {
            return;
        }

        let source = layer.getSource();
        let visible = projectId ? true : false;
        let filter = visible ? `r_projectglobalid='${projectId}'` : null;
        switch (source.constructor) {
            case ImageWMS: {
                (source as ImageWMS).updateParams({ 'cql_filter': filter });
                break;
            }

            case TileWMS: {
                (source as TileWMS).updateParams({ 'cql_filter': filter });
                break;
            }

            case ImageArcGISRest:
            case TileArcGISRest: {
                let arcGisRestSource: ImageArcGISRest | TileArcGISRest;
                switch (source.constructor) {
                    case ImageArcGISRest: {
                        arcGisRestSource = source as ImageArcGISRest;
                        break;
                    }

                    case TileArcGISRest: {
                        arcGisRestSource = source as TileArcGISRest;
                        break;
                    }
                }

                let layerDefs = arcGisRestSource.getParams()["layerDefs"] ? JSON.parse(arcGisRestSource.getParams()["layerDefs"]) : null;
                if (!layerDefs) {
                    layerDefs = {};
                }

                for (let i = 0; i < layerIds.length; i++) {
                    let layerId = layerIds[i].toString();
                    if (filter) {
                        layerDefs[layerId] = filter;
                    }
                    else if (layerDefs.hasOwnProperty(layerId)) {
                        delete layerDefs[layerId];
                    }
                }

                arcGisRestSource.updateParams({ layerDefs: JSON.stringify(layerDefs) });
                break;
            }
        }

        for (let i = 0; i < layerIds.length; i++) {
            let legendItem = self.legendSearch(item => item.layerNameOnMap == layerName && item.id == layerIds[i]);
            let node = legendItem ? $(`li[data-uid="${legendItem.uid}"]`) : null;
            if (legendItem && node && node.attr("aria-checked") != visible.toString()) {
                legendItem.set("checked", visible);
                self.legend.trigger("check", { sender: self.legend, node: node });
            }
        }

        displayMessage(getResource("SuccessAction"), messageType.success);
    }

    private updateHistoryMoment = (historyMoment: number) => {
        let self = this;
        let layerName = self.cadastreHistoryLayersData[0].name;
        let layerIds = self.cadastreHistoryLayersData.map(item => item.layerId);
        let layer = self.getLayerByName(layerName) as Layer;
        if (!layer) {
            return;
        }

        let source = self.getArcGisLayerSource(layer);
        source.updateParams({ historicMoment: historyMoment });

        let rootItem = self.legendSearch(item => item.name == layerName && !item.id);
        if (rootItem) {
            let historyDate = self.getHistoryDate(historyMoment);
            rootItem.set("title", `${getResource(layerName)}: ${kendo.toString(historyDate, 'g')}`);
        }

        let visible = historyMoment > 0 ? true : false;
        for (let i = 0; i < layerIds.length; i++) {
            let legendItem = self.legendSearch(item => item.layerNameOnMap == layerName && item.id == layerIds[i]);
            let node = legendItem ? $(`li[data-uid="${legendItem.uid}"]`) : null;
            if (legendItem && node && node.attr("aria-checked") != visible.toString()) {
                legendItem.set("checked", visible);
                self.legend.trigger("check", { sender: self.legend, node: node });
            }
        }

        displayMessage(getResource("SuccessAction"), messageType.success);
    }

    private getFeatureFormat = (format: string): WKT | EsriJSON => {
        format = format ? format.toLowerCase() : "";
        switch (format) {
            case "esrijson": {
                return new EsriJSON();
            }

            default: {
                return new WKT();
            }
        }
    }

    private getReadFeatureGeometryOptions = (spatialReferenceCode: string, format?: WKT | EsriJSON) => {
        let self = this;
        let mapProjection = self.map.getView().getProjection().getCode();
        let prefix = format && format instanceof EsriJSON ? "EPSG" : "$EPSG";
        let projection = spatialReferenceCode ? `${prefix}:${spatialReferenceCode}` : null;
        return projection && projection != mapProjection
            ? {
                dataProjection: projection,
                featureProjection: mapProjection
            }
            : null;
    }

    private closeOldMapWindows = () => {
        let self = this;
        $(`.${self.mapWindowClass}[data-role='window']`).each((index, item) => {
            let mapWindow = $(item).data("kendoWindow") as kendo.ui.Window;
            if (mapWindow) {
                mapWindow.close();
            }
        });
    }

    private openNewMapWindow = (content: string, options?: kendo.ui.WindowOptions, closeOld: boolean = false) => {
        let self = this;
        if (closeOld) {
            self.closeOldMapWindows();
        }

        if (!content) {
            return;
        }

        if (!options) {
            options = {}
        }

        options.classAttribute = self.mapWindowClass
        openKendoWindowContent(content, options);
    }

    private getArcGisLayerSource = (layer: Layer): ImageArcGISRest | TileArcGISRest => {
        let source = layer.getSource();
        switch (source.constructor) {
            case ImageArcGISRest: {
                return source as ImageArcGISRest;
            }

            case TileArcGISRest: {
                return source as TileArcGISRest;
            }
        }
    }

    private getHistoryDate = (historyMoment: number): Date => {
        // TODO - is not correct map UTC - use local time
        return historyMoment > 0 ? new Date(+historyMoment) : new Date();
    }

    private initFloorsDropDown = (wrapper: JQuery<HTMLElement>, layer: Layer = null): void => {
        let self = this;
        let floorsDropDown = wrapper.find("input.floor-js").data("kendoDropDownList") as kendo.ui.DropDownList;
        if (floorsDropDown) {
            let bind = floorsDropDown.element.data("bind");
            let filterTamplate = floorsDropDown.element.data("filter");
            if (bind) {
                floorsDropDown.setDataSource(
                    new kendo.data.DataSource({
                        data: bind
                    }));
                floorsDropDown.select(0);
            }

            let floorApartmentsListView = wrapper.find(".floorApartments-js:first").data("kendoListView");
            floorsDropDown.bind("change", (e: kendo.ui.DropDownListChangeEvent) => {
                let floor = floorsDropDown.value();
                if (floorApartmentsListView) {
                    floorApartmentsListView.element.data("floornumber", floor);
                    floorApartmentsListView.dataSource.read();
                }
                self.selectionLayer.getSource().clear(true);
                if (filterTamplate) {
                    if (layer) {
                        let filter = kendo.template(filterTamplate)(e.sender.dataItem());
                        let source = layer.getSource();
                        (source as ImageWMS).updateParams({ 'cql_filter': filter });
                    }
                }
                else {
                    self.updateApartmentLayerFilterByObject(floorsDropDown.element.data("number"), floorsDropDown.element.data("type"), floor);
                    self.updateRestrictionLayerFilterByObject(floorsDropDown.element.data("number"), floorsDropDown.element.data("type"), floor);
                }
            });
            floorsDropDown.trigger("change");
        }
    }
}